import Layout from "../views/layout/layout";

export default [
    {
        path: "/data",
        name: "data",
        component: Layout,
        children: [
            {
                path: "/feedback/index",
                name: "feedback",
                component: () => import("../views/data/feedback/index"),
                meta: {title: "客户app意见反馈", keepAlive: true},
            },
        ],
    },
    {
        path: "/royalty",
        name: "royalty",
        component: Layout,
        children: [
            {
                path: "/royalty/plan/index",
                name: "royaltyPlan",
                component: () => import("../views/biz/royalty/plan/index"),
                meta: {title: "角色提成方案", keepAlive: true},
            },
            {
                path: "/royalty/plan/detail",
                name: "royaltyPlanDetail",
                component: () => import("../views/biz/royalty/plan/detail"),
                meta: {title: "角色提成方案设定"},
            },
            {
                path: "/royalty/plan/setting",
                name: "setRoyaltyPlan",
                component: () => import("../views/biz/royalty/plan/setPlan"),
                meta: {title: "角色提成方案设定"},
            },
            {
                path: "/private/royalty",
                name: "royaltyIndex",
                component: () => import("../views/biz/royalty/private/royaltyIndex"),
                meta: {title: "提成查询", keepAlive: true},
            },
            {
                path: "/royalty/settlement",
                name: "settlementIndex",
                component: () => import("../views/biz/royalty/settlement/index"),
                meta: {title: "提成结算单", keepAlive: true},
            },
            {
                path: "/private/pay",
                name: "payIndex",
                component: () => import("../views/biz/royalty/private/payIndexNew"),
                meta: {title: "提成审核", keepAlive: true},
            },
            {
                path: "/private/payPersonDetail",
                name: "payPersonDetail",
                component: () => import("../views/biz/royalty/private/payPersonDetail"),
                meta: {title: "发放明细", keepAlive: true},
            },
            {
                path: "/settlement/detail",
                name: "privateCommission",
                component: () =>
                    import("../views/biz/royalty/settlement/commission/index"),
                meta: {title: "收入详情", keepAlive: true},
            },
            {
                path: "/triggerConfig/index",
                name: "triggerConfig",
                component: () => import("../views/biz/royalty/triggerConfig/index"),
                meta: {title: "事件触发配置", keepAlive: true},
            },
        ],
    },
    {
        path: "/channel",
        //栏目
        name: "栏目",
        component: Layout,
        meta: {
            title: "栏目管理",
        },
        iconCls: "icon-appstoreo",
        redirect: "/channel/list",
        isParent: true,
        leaf: true,
        //只有一个节点
        children: [
            {
                path: "/channel/list",
                name: "栏目列表",
                //栏目列表
                meta: {
                    title: "栏目列表",
                },
                component: () => import("../views/channel/list"),
                hidden: true,
            },
            {
                path: "/channel/save",
                name: "栏目添加",
                //栏目添加
                meta: {
                    title: "栏目添加",
                },
                component: () => import("../views/channel/add"),
                hidden: true,
            },
            {
                path: "/channel/update",
                name: "栏目修改",
                //栏目修改
                meta: {
                    title: "栏目修改",
                },
                component: () => import("../views/channel/edit"),
                hidden: true,
            },
            {
                path: "/channel/copy",
                name: "栏目复制",
                //栏目复制
                meta: {
                    title: "栏目复制",
                },
                component: () => import("../views/channel/copy"),
                hidden: true,
            },
        ],
    },
    {
        path: "/model",
        name: "模型管理",
        //模型管理
        meta: {
            title: "模型管理",
        },
        component: Layout,
        isParent: true,
        redirect: "/model/list",
        children: [
            {
                path: "/model/list",
                name: "模型列表",
                //模型管理列表
                meta: {
                    title: "模型列表",
                },
                component: () => import("../views/model/list"),
            },
            {
                path: "/model/add",
                name: "模型添加",
                //模型管理添加
                meta: {
                    title: "模型添加",
                },
                component: () => import("../views/model/edit"),
            },
            {
                path: "/model/edit",
                name: "模型修改",
                //模型管理修改
                meta: {
                    title: "模型修改",
                },
                component: () => import("../views/model/edit"),
            },
            {
                path: "/channelModel/list",
                name: "栏目模型字段列表",
                //栏目模型
                meta: {
                    title: "栏目模型字段列表",
                },
                component: () => import("../views/model/item/channel/list"),
            },
            {
                path: "/channelModel/update",
                name: "栏目模型字段修改",
                //栏目模型项修改
                meta: {
                    title: "栏目模型字段修改",
                },
                component: () => import("../views/model/item/channel/edit"),
            },
            {
                path: "/channelModel/save",
                name: "栏目模型字段添加",
                //栏目模型项添加
                meta: {
                    title: "栏目模型字段添加",
                },
                component: () => import("../views/model/item/channel/edit"),
            },
            {
                path: "/contentModel/list",
                name: "内容模型字段模型",
                //内容模型
                meta: {
                    title: "内容模型字段模型",
                },
                component: () => import("../views/model/item/content/list"),
            },
            {
                path: "/contentModel/update",
                name: "内容模型字段修改",
                //内容模型项修改
                meta: {
                    title: "内容模型字段修改",
                },
                component: () => import("../views/model/item/content/edit"),
            },
            {
                path: "/contentModel/save",
                name: "内容模型字段添加",
                //内容模型项添加
                meta: {
                    title: "内容模型字段添加",
                },
                component: () => import("../views/model/item/content/edit"),
            },
        ],
    },
    {
        path: "/customer",
        name: "customerIndex",
        redirect: "/customer/index",
        component: Layout,
        children: [
            {
                name: "customerproductionPlanIndex",
                path: "/customer/productionPlan/index",
                component: () => import("../views/customer/productionPlan/index"),
                meta: {
                    title: "营销月度产值计划铺排",
                    keepAlive: true,
                },
            },
            {
                name: "customerproductionPlanAdmin",
                path: "/customer/productionPlan/administration",
                component: () =>
                    import("../views/customer/productionPlan/administration"),
                meta: {
                    title: "营销月度产值计划管理",
                    keepAlive: true,
                },
            },
            {
                name: "customerproductionPlanDetail",
                path: "/customer/productionPlan/detail",
                component: () =>
                    import("../views/customer/productionPlan/productionPlanDetail/index"),
                meta: {
                    title: "营销月度产值计划铺排",
                },
            },
            {
                name: "customerproductionPlanAdd",
                path: "/customer/productionPlan/add",
                component: () =>
                    import("../views/customer/productionPlan/addCustomer/index"),
                meta: {
                    title: "营销月度产值计划铺排",
                },
            },
            {
                name: "customerproductionPlanMaintain",
                path: "/customer/productionPlan/maintain",
                component: () =>
                    import(
                        "../views/customer/productionPlan/productionPlanMaintain/index"
                        ),
                meta: {
                    title: "营销月度产值计划铺排",
                },
            },
            // {
            //       path: '/customer/index',
            //       name: 'customerList',
            //       component:()=>import('../views/customer/index'),
            //       meta: {
            //           title: '营销月度产值计划铺排',
            //           keepAlive: true
            //       }
            //   },
            {
                path: "/customer/index",
                name: "customerList",
                component: () => import("../views/customer/index"),
                meta: {
                    title: "客户管理",
                    keepAlive: true,
                },
            },
            {
                path: "/customer/addSource",
                name: "customerSource_add",
                component: () => import("../views/customer/addSource"),
                meta: {
                    title: "新增客户资源",
                },
            },
            {
                path: "/customer/editSource",
                name: "customerSource_edit",
                component: () => import("../views/customer/editSource"),
                meta: {
                    title: "完善客户资源信息",
                },
            },
            {
                path: "/customer/detailSource",
                name: "customerSource_detail",
                component: () => import("../views/customer/detailSource"),
                meta: {
                    title: "客户资源详情",
                },
            },
            {
                path: "/customer/supplement",
                name: "Supplement",
                component: () => import("../views/customer/form/customer_addInfo"),
                meta: {
                    title: "补充客户信息",
                },
            },
            {
                path: "/customer/resource",
                name: "Resource",
                component: () => import("../views/customer/form/customer_resourceA"),
                meta: {
                    title: "资源分配",
                },
            },
            {
                path: "/customer/add",
                name: "Add",
                component: () => import("../views/customer/form/customer_add"),
                meta: {
                    title: "客户增加",
                },
            },
            {
                path: "/customer/life",
                name: "Life",
                component: () => import("../views/customer/form/customer_life_cycle"),
                meta: {
                    title: "生命周期",
                },
            },
            {
                path: "/customer/info",
                name: "customerInfo",
                component: () => import("../views/customer/form/customerInformation"),
                meta: {
                    title: "查询客户信息",
                },
            },
        ],
    },
    {
        path: "/target",
        name: "target",
        redirect: "/target/index",
        component: Layout,
        children: [
            {
                name: "targetIndex",
                path: "/target/index",
                component: () => import("../views/target/targetSetting/index"),
                meta: {
                    title: "目标制定",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/book",
        name: "Book",
        redirect: "/book/index",
        component: Layout,
        children: [
            {
                path: "/book/index",
                name: "bookIndex",
                component: () => import("../views/resources/book/index"),
                meta: {
                    title: "预约管理",
                    keepAlive: true,
                },
            },
            {
                path: "/book/createOrderOnline",
                name: "createOrderOnline",
                component: () => import("../views/resources/book/createOrderOnline"),
                meta: {
                    title: "创建资源(预约管理)",
                },
            },
        ],
    },
    {
        path: "/order",
        name: "order",
        redirect: "/order/index",
        component: Layout,
        children: [
            {
                path: "/order/orderForManage",
                name: "orderForManage",
                component: () => import("../views/resources/order/orderForManage"),
                meta: {
                    title: "客户资源",
                },
            },
            {
                path: "/order/index",
                name: "orderIndex",
                component: () => import("../views/resources/order/orderIndex"),
                meta: {
                    title: "公海资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/pond",
                name: "orderPond",
                component: () => import("../views/resources/order/orderPond"),
                meta: {
                    title: "鱼塘资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/nonGround",
                name: "orderNonGround",
                component: () => import("../views/resources/order/orderNonGround"),
                meta: {
                    title: "非地勤资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/online",
                name: "orderOnline",
                component: () => import("../views/resources/order/online/orderOnline"),
                meta: {
                    title: "网推资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/onlineSale",
                name: "orderOnlineSale",
                component: () =>
                    import("../views/resources/order/online/orderOnlineSale"),
                meta: {
                    title: "网销资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/onlineManager",
                name: "orderOnlineManager",
                component: () =>
                    import("../views/resources/order/online/orderOnlineManager"),
                meta: {
                    title: "网销经理资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/customerServiceManager",
                name: "orderCustomerServiceManager",
                component: () =>
                    import("../views/resources/order/online/orderCustomerServiceManager"),
                meta: {
                    title: "网销资源-在线客服",
                    keepAlive: true,
                },
            },
            {
                path: "/order/abandon",
                name: "orderAbandon",
                component: () => import("../views/resources/order/orderAbandon"),
                meta: {
                    title: "废单资源",
                    keepAlive: true,
                },
            },
            {
                path: "/order/form",
                name: "orderForm",
                component: () => import("../views/resources/order/order"),
                meta: {
                    title: "创建资源",
                },
            },
            {
                path: "/order/createOnline",
                name: "newOnline",
                component: () => import("../views/resources/order/online/newOnline"),
                meta: {
                    title: "创建资源",
                },
            },
            {
                path: "/order/form/improve",
                name: "orderFormImprove",
                component: () => import("../views/resources/order/order"),
                meta: {
                    title: "完善资源",
                },
            },
            {
                path: "/order/improveOnline",
                name: "createOnline",
                component: () => import("../views/resources/order/online/createOnline"),
                meta: {
                    title: "完善资源",
                },
            },
            {
                path: "/order/updateOnline",
                name: "updateOnline",
                component: () => import("../views/resources/order/online/updateOnline"),
                meta: {
                    title: "修改资源",
                },
            },
            {
                path: "/order/form/edit",
                name: "orderFormEdit",
                component: () => import("../views/resources/order/order"),
                meta: {
                    title: "修改资源",
                },
            },
            {
                path: "/order/life",
                name: "orderLife",
                component: () => import("../views/resources/order/orderLife"),
                meta: {
                    title: "资源生命周期",
                },
            },
            {
                path: "/order/lifeGround",
                name: "orderLifeGround",
                component: () => import("../views/resources/order/orderLifeGround"),
                meta: {
                    title: "地勤资源生命周期",
                },
            },
            {
                path: "/online/life",
                name: "onlineLife",
                component: () => import("../views/resources/order/online/onlineLife"),
                meta: {
                    title: "客户资源详情",
                },
            },
            {
                path: "/online/orderService",
                name: "onlineOrderService",
                component: () =>
                    import("../views/resources/order/online/orderServiceDetail"),
                meta: {
                    title: "服务订单详情",
                },
            },
            {
                path: "/order/detail",
                name: "orderDetail",
                component: () => import("../views/resources/order/orderLife"),
                meta: {
                    title: "资源详情",
                },
            },
            {
                path: "/order/service",
                name: "orderViewService",
                component: () => import("../views/resources/order/orderViewService"),
                meta: {
                    title: "服务订单查看",
                },
            },
            {
                path: "/order/orderDispatch",
                name: "orderDispatch",
                component: () => import("../views/resources/order/orderDispatch"),
                meta: {
                    title: "分派资源",
                },
            },
            {
                path: "/order/orderTrack",
                name: "Follow",
                component: () => import("../views/resources/order/orderTrackMan"),
                meta: {
                    title: "跟进管理",
                },
            },
            {
                path: "/order/addTrack",
                name: "AddOrderTrackaddTrack",
                component: () => import("../views/resources/order/newOrderTrack"),
                meta: {
                    title: "新增跟进",
                },
            },
            {
                path: "/order/editTrack",
                name: "AddOrderTrackeditTrack",
                component: () => import("../views/resources/order/newOrderTrack"),
                meta: {
                    title: "修改跟进",
                },
            },
            {
                path: "/order/addOrderTrack",
                name: "AddOrderTrackaddOrderTrack",
                component: () => import("../views/resources/order/newOrderTrack"),
                meta: {
                    title: "资源跟进管理",
                },
            },
            {
                path: "/order/info",
                name: "orderInformation",
                component: () => import("../views/resources/order/orderInformation"),
                meta: {
                    title: "查看需求资源",
                },
            },
            {
                path: "/order/mark",
                name: "orderMark",
                component: () => import("../views/resources/order/orderMark"),
                meta: {
                    title: "打标签",
                },
            },
            {
                path: "/online/mark",
                name: "orderMarkOnline",
                component: () => import("../views/resources/order/online/onlineMark"),
                meta: {
                    title: "打标签",
                },
            },
            {
                path: "/order/repeat",
                name: "orderRepeat",
                component: () => import("../views/resources/order/orderRepeat"),
                meta: {
                    title: "相似资源",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/onlineSettingValue",
        name: "onlineSettingValue",
        component: Layout,
        redirect: "/onlineSettingValue/index",
        children: [
            {
                path: "/onlineSettingValue/index",
                name: "onlineSettingValueIndex",
                component: () => import("../views/customer/onlineSettingValue/index"),
                meta: {
                    title: "网销目标产值维护",
                },
            },
        ],
    },


    {
        path: "/member",
        name: "member",
        component: Layout,
        redirect: "/member/memberIndex",
        children: [
            {
                path: "/member/memberIndex",
                name: "Member",
                component: () => import("../views/customer/memberIndex"),
                meta: {
                    title: "会员管理",
                    keepAlive: true,
                },
            },
            {
                path: "/member/memberInfo",
                name: "memberInfo",
                component: () => import("../views/customer/memberInfoWithTags"),
                meta: {
                    title: "查看会员",
                },
            },
            {
                path: "/member/LifeCycle",
                name: "memberLifeCycle",
                component: () => import("../views/customer/form/memberLifeCycle"),
                meta: {
                    title: "查看会员生命周期",
                },
            },
        ],
    },

    {
        path: "/version",
        name: "version",
        component: Layout,
        redirect: "/content/version",
        children: [
            {
                path: "/content/version",
                name: "versionContent",
                component: () => import("../views/content/version"),
                meta: {
                    title: "版本信息",
                },
            },
        ],
    },
    //商务管理路由
    {
        path: "/graphic",
        name: "graphic",
        component: Layout,
        redirect: "/graphic/index",
        children: [
            {
                path: "/graphic/index",
                name: "graphicIndex",
                component: () => import("../views/biz/graphic/index"),
                meta: {
                    title: "平面规划方案管理",
                    keepAlive: true,
                },
            },
            {
                path: "/graphic/add",
                name: "graphic_add",
                component: () => import("../views/biz/graphic/form/add_graphic"),
                meta: {
                    title: "上传平面设计图",
                },
            },
            {
                path: "/graphic/detail",
                name: "graphicDetail",
                component: () => import("../views/biz/graphic/form/graphicDetail"),
                meta: {
                    title: "平面设计详情查看",
                },
            },
        ],
    },
    //客服管理路由
    {
        path: "/customerService",
        name: "customerService",
        component: Layout,
        redirect: "/customerService/index",
        children: [
            {
                path: "/customerService/returnVisit/index",
                name: "returnVisit",
                component: () =>
                    import("../views/biz/customerService/returnVisit/index"),
                meta: {
                    title: "客服管理",
                    keepAlive: true,
                },
            },
            {
                path: "/customerService/questionnaire/index",
                name: "questionnairePush",
                component: () =>
                    import("../views/biz/customerService/questionnaire/index"),
                meta: {
                    title: "问卷推送",
                    keepAlive: true,
                },
            },
            {
                path: "/customerService/questionnaire/detail",
                name: "questionnaireDetail",
                component: () =>
                    import("../views/biz/customerService/questionnaire/questionnaireDetail"),
                meta: {
                    title: "评测详情",

                },
            },
            {
                path: "/workOrder/page/index",
                name: "workOrderPage",
                component: () =>
                    import("../views/biz/workOrder/page/index"),
                meta: {
                    title: "工单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/customerService/workOrderDeploy",
                name: "workOrderDeploy",
                component: () =>
                    import("../views/biz/workOrderDeploy/index"),
                meta: {
                    title: "工单客服配置",
                    keepAlive: true,
                },
            },
            {
                path: "/customerService/returnVisit/startWork",
                name: "startWorking",
                component: () =>
                    import("../views/biz/customerService/returnVisit/startWork"),
                meta: {title: "开工令回访"},
            },
            {
                path: "/customerService/returnVisit/orderSituation",
                name: "orderSituation",
                component: () =>
                    import("../views/biz/customerService/returnVisit/orderSituation"),
                meta: {title: "下单情况"},
            },
            {
                path: "/customerService/returnVisit/endWork",
                name: "endWorking",
                component: () =>
                    import("../views/biz/customerService/returnVisit/startWork"),
                meta: {title: "完工回访"},
            },
            {
                path: "/workOrder/add",
                name: "addWorkOrder",
                component: () =>
                    import("../views/biz/workOrder/page/addWorkOrder"),
                meta: {title: "创建工单"},
            },
            {
                path: "/workOrder/detail",
                name: "workOrderDetail",
                component: () =>
                    import("../views/biz/workOrder/page/workOrderDetail"),
                meta: {title: "工单详情"},
            },
            {
                path: "/workOrderTypeDeploy/index",
                name: "workOrderTypeDeploy",
                component: () =>
                    import("../views/biz/workOrderTypeDeploy/index"),
                meta: {
                    title: "工单问题类型配置",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/resourceMonitoring",
        name: "resourceMonitoring",
        component: Layout,
        redirect: "/resourceMonitoring/index",
        children: [
            {
                path: "/resourceMonitoring/index",
                name: "resourceMonitoringIndex",
                component: () => import("../views/biz/billboard/index"),
                meta: {
                    title: "资源盯控",
                    keepAlive: true,
                },
            },
            {
                path: "/resourceSaleMan",
                name: "resourceSaleMan",
                component: () => import("../views/biz/billboard/indexForSaleMan"),
                meta: {
                    title: "资源盯控营销主管",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/neededStuffConfig",
        name: "neededStuffConfig",
        component: Layout,
        redirect: "/neededStuffConfig/index",
        children: [
            {
                path: "/neededStuffConfig/index",
                name: "neededStuffConfig_index",
                component: () => import("../views/biz/neededStuffConfig/index"),
                meta: {
                    title: "配置管理",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/neededStuffOrder",
        name: "neededStuffOrder",
        component: Layout,
        redirect: "/neededStuffOrder/index",
        children: [
            {
                path: "/neededStuffOrder/index",
                name: "neededStuffOrder_index",
                component: () => import("../views/biz/neededStuffOrder/index"),
                meta: {
                    title: "必选大类管理",
                    keepAlive: true,
                },
            },
            {
                path: "/neededStuffOrder/detail",
                name: "neededStuffOrder_detail",
                component: () => import("../views/biz/neededStuffOrder/form/detail"),
                meta: {
                    title: "必选大类明细",
                },
            },
        ],
    },
    //月度产值计划铺排
    {
        path: "/productionPlan",
        name: "productionPlan",
        redirect: "/productionPlan/index",
        component: Layout,
        children: [
            {
                name: "productionPlanIndex",
                path: "/productionPlan/index",
                component: () => import("../views/biz/productionPlan/index"),
                meta: {
                    title: "月度产值计划铺排",
                    keepAlive: true,
                },
            },
            {
                name: "productionPlanAdmin",
                path: "/productionPlan/administration",
                component: () => import("../views/biz/productionPlan/administration"),
                meta: {
                    title: "月度产值计划管理",
                    keepAlive: true,
                },
            },
            {
                name: "productionPlanDetail",
                path: "/productionPlan/detail",
                component: () =>
                    import("../views/biz/productionPlan/productionPlanDetail/index"),
                meta: {
                    title: "月度产值计划铺排",
                },
            },
            {
                name: "productionPlanAdd",
                path: "/productionPlan/add",
                component: () =>
                    import("../views/biz/productionPlan/addCustomer/index"),
                meta: {
                    title: "月度产值计划铺排",
                },
            },
            {
                name: "productionPlanMaintain",
                path: "/productionPlan/maintain",
                component: () =>
                    import("../views/biz/productionPlan/productionPlanMaintain/index"),
                meta: {
                    title: "月度产值计划铺排",
                },
            },
        ],
    },
    {
        path: "/productionPlanSheet",
        name: "NetpinProductionPlanSheet",
        redirect: "/productionPlanSummarySheet",
        component: Layout,
        children: [
            {
                name: "NetpinproductionPlanSummarySheet",
                path: "/Netpin/productionPlanSummarySheet",
                component: () =>
                    import(
                        "../views/customer/productionPlanSheet/productionPlanSummarySheet"
                        ),
                meta: {
                    title: "营销月度产值计划汇总表",
                    keepAlive: true,
                },
            },
            {
                name: "NetpinproductionPlanDetailSheet",
                path: "/Netpin/productionPlanDetailSheet",
                component: () =>
                    import(
                        "../views/customer/productionPlanSheet/productionPlanDetailSheet"
                        ),
                meta: {
                    title: "网销月度产值计划明细表",
                    keepAlive: true,
                },
            },
        ],
    },

    //月度产值计划表
    {
        path: "/productionPlanSheet",
        name: "productionPlanSheet",
        redirect: "/productionPlanSummarySheet",
        component: Layout,
        children: [
            {
                name: "productionPlanSummarySheet",
                path: "/productionPlanSummarySheet",
                component: () =>
                    import("../views/biz/productionPlanSheet/productionPlanSummarySheet"),
                meta: {
                    title: "月度产值计划汇总表",
                    keepAlive: true,
                },
            },
            {
                name: "productionPlanDetailSheet",
                path: "/productionPlanDetailSheet",
                component: () =>
                    import("../views/biz/productionPlanSheet/productionPlanDetailSheet"),
                meta: {
                    title: "月度产值计划明细表",
                    keepAlive: false,
                },
            },
        ],
    },
    //选材报价
    {
        path: "/offer",
        name: "offer",
        component: Layout,
        children: [
            {
                path: "/offer/index",
                name: "index",
                component: () => import("../views/offer/index"),
                meta: {
                    title: "报价单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/offer/indexSupply",
                name: "indexSupply",
                component: () => import("../views/offer/indexSupply"),
                meta: {
                    title: "报价单管理(供应商)",
                    keepAlive: true,
                },
            },
            {
                path: "/offer/select",
                name: "offer_select",
                component: () => import("../views/offer/form/select_customer_info"),
                meta: {
                    title: "选择客户信息",
                },
            },
            {
                path: "/offer/sumBizOffer",
                name: "offer_sum",
                component: () => import("../views/offer/form/offer_sum"),
                meta: {
                    title: "报价单汇总",
                },
            },
            {
                path: "/offer/update",
                name: "offer_update",
                component: () => import("../views/offer/form/offer_update"),
                meta: {
                    title: "修改报价单",
                },
            },
            {
                path: "/offer/alreadyDetail",
                name: "alreadyDetail",
                component: () => import("../views/offer/alreadyDetail"),
                meta: {
                    title: "报价单明细",
                },
            },
            {
                path: "/offer/selectProduct",
                name: "selectProduct",
                component: () => import("../views/offer/selectProduct"),
                meta: {
                    title: "修改报价单",
                },
            },
            {
                path: "/offer/offerAdd",
                name: "offerAdd",
                component: () => import("../views/offer/form/offer_add"),
                meta: {
                    title: "选择商品",
                },
            },
            {
                path: "/offer/customerDetail",
                name: "customerDetail",
                component: () => import("../views/offer/customerDetail"),
                meta: {
                    title: "客户已确认明细",
                },
            },
            {
                path: "/offer/first",
                name: "first",
                component: () => import("../views/offer/first"),
                meta: {
                    title: "报价单新增",
                },
            },
            {
                path: "/offer/detail",
                name: "detail",
                component: () => import("../views/offer/detail"),
                meta: {
                    title: "报价单明细",
                },
            },
        ],
    },
    {
        path: "/Order",
        name: "Order",
        component: Layout,
        redirect: "/Order/index",
        children: [
            {
                path: "/Order/saleOrder/sales_order",
                name: "sales_order",
                component: () => import("../views/order/saleOrder/sales_order"),
                meta: {
                    title: "销售订单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/saleOrder/select_offer",
                name: "select_offer",
                component: () => import("../views/order/saleOrder/offer_order_table"),
                meta: {
                    title: "选择报价单",
                },
            },
            {
                path: "/Order/saleOrder/add_sale",
                name: "add_sale",
                component: () => import("../views/order/saleOrder/sale_order_add"),
                meta: {
                    title: "新增销售订单",
                },
            },
            {
                path: "/Order/saleOrder/update_sale",
                name: "update_sale",
                component: () => import("../views/order/saleOrder/sale_order_update"),
                meta: {
                    title: "编辑销售订单",
                },
            },
            {
                path: "/Order/saleOrder/purchaseOrderAdd",
                name: "saleOrderPurchaseOrderAdd",
                component: () => import("../views/order/saleOrder/purchaseOrderAdd"),
                meta: {
                    title: "创建采购单",
                },
            },
            {
                path: "/Order/purchaseOrder/applySettlement",
                name: "applySettlement",
                component: () => import("../views/order/purchaseOrder/applySettlement"),
                meta: {
                    title: "申请结算",
                },
            },
            {
                path: "/Order/saleOrder/purchaseOrderPreview",
                name: "purchaseOrderPreview",
                component: () =>
                    import("../views/order/saleOrder/purchaseOrderPreview"),
                meta: {
                    title: "我的采购单",
                },
            },
            {
                path: "/Order/saleOrder/sales_order_preview",
                name: "sales_order_preview",
                component: () => import("../views/order/saleOrder/sales_order_preview"),
                meta: {
                    title: "销售订单详情",
                },
            },
            {
                path: "/Order/saleOrder/return_order_preview",
                name: "return_order_preview",
                component: () =>
                    import("../views/order/saleOrder/return_order_preview"),
                meta: {
                    title: "返利订单详情",
                },
            },
            {
                path: "/Order/saleOrder/return_order",
                name: "return_order",
                component: () => import("../views/order/saleOrder/return_order"),
                meta: {
                    title: "返利订单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/reformSupply/return_order",
                name: "return_reformSupply_order",
                component: () => import("../views/order/reformSupply/return_order"),
                meta: {
                    title: "拆改建返利订单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/reformSupply/return_order_update",
                name: "return_order_update_reform",
                component: () => import("../views/order/reformSupply/return_order_update"),
                meta: {
                    title: "修改拆改建返利订单",
                },
            },
            {
                path: "/Order/reformSupply/return_order_preview",
                name: "return_order_preview_reform",
                component: () => import("../views/order/reformSupply/return_order_preview"),
                meta: {
                    title: "拆改建返利订单详情",
                },
            },
            {
                path: "/Order/reformSupply/return_order_add",
                name: "return_order_add",
                component: () => import("../views/order/reformSupply/return_order_add"),
                meta: {
                    title: "新增拆改建返利订单",
                },
            },
            {
                path: "/finance/reformSupply/return_receivables",
                name: "return_receivables",
                component: () => import("../views/finance/reformSupply/return_receivables"),
                meta: {
                    title: "拆改建供应商收款",
                    keepAlive: true,
                },
            },
            {
                path: "/finance/reformSupply/return_receivables_add",
                name: "return_receivables_add",
                component: () => import("../views/finance/reformSupply/return_receivables_add"),
                meta: {
                    title: "新增拆改建供应商收款",
                },
            },
            {
                path: "/finance/reformSupply/return_receivables_update",
                name: "return_receivables_update",
                component: () => import("../views/finance/reformSupply/return_receivables_update"),
                meta: {
                    title: "修改拆改建供应商收款",
                },
            },
            {
                path: "/finance/reformSupply/return_receivables_preview",
                name: "return_receivables_preview",
                component: () => import("../views/finance/reformSupply/return_receivables_preview"),
                meta: {
                    title: "拆改建供应商收款详情",
                },
            },
            {
                path: "/Order/saleOrder/return_order_add",
                name: "return_order_add_sale",
                component: () => import("../views/order/saleOrder/return_order_add"),
                meta: {
                    title: "返利订单添加",
                },
            },
            {
                path: "/Order/saleOrder/return_order_update",
                name: "return_order_update",
                component: () => import("../views/order/saleOrder/return_order_update"),
                meta: {
                    title: "返利订单编辑",
                },
            },
            {
                path: "/Order/saleOrder/discount_order",
                name: "discount_order",
                component: () => import("../views/order/saleOrder/discount_order"),
                meta: {
                    title: "优惠单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/saleOrder/discount_order_add",
                name: "discount_order_add",
                component: () => import("../views/order/saleOrder/discount_order_add"),
                meta: {
                    title: "新增优惠单",
                },
            },
            {
                path: "/Order/saleOrder/discount_order_view",
                name: "discount_order_view",
                component: () => import("../views/order/saleOrder/discount_order_view"),
                meta: {
                    title: "优惠单详情",
                },
            },
            {
                path: "/Order/saleOrder/discount_order_update",
                name: "discount_order_update",
                component: () =>
                    import("../views/order/saleOrder/discount_order_update"),
                meta: {
                    title: "优惠单修改",
                },
            },
            {
                path: "/Order/purchaseOrder/purchase_order_menu",
                name: "purchase_order_menu",
                component: () =>
                    import("../views/order/purchaseOrder/purchase_order_menu"),
                meta: {
                    title: "采购单管理(星杰)",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/purchaseOrder/purchase_order_menu_supply",
                name: "purchase_order_menu_supply",
                component: () =>
                    import("../views/order/purchaseOrder/purchase_order_menu_supply"),
                meta: {
                    title: "采购单管理(供应商)",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/purchaseOrder/purchaseOrderAdd",
                name: "purchaseOrderAdd",
                component: () =>
                    import("../views/order/purchaseOrder/purchaseOrderAdd"),
                meta: {
                    title: "创建采购单",
                },
            },
            {
                path: "/Order/purchaseOrder/delivery_note_menu",
                name: "delivery_note_menu",
                component: () =>
                    import("../views/order/purchaseOrder/delivery_note_menu"),
                meta: {
                    title: "送货单管理(星杰)",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/purchaseOrder/delivery_note_menu_supply",
                name: "delivery_note_menu_supply",
                component: () =>
                    import("../views/order/purchaseOrder/delivery_note_menu_supply"),
                meta: {
                    title: "送货单管理(供应商)",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/purchaseOrder/sendOrderAdd",
                name: "sendOrderAdd",
                component: () => import("../views/order/purchaseOrder/sendOrderAdd"),
                meta: {
                    title: "送货单新增",
                },
            },
            {
                path: "/Order/purchaseOrder/send_order_add",
                name: "sendOrderAddPurchase",
                component: () => import("../views/order/purchaseOrder/send_order_add"),
                meta: {
                    title: "送货单新增",
                },
            },
            {
                path: "/Order/purchaseOrder/sendOrderUpdate",
                name: "sendOrderUpdate",
                component: () => import("../views/order/purchaseOrder/sendOrderUpdate"),
                meta: {
                    title: "送货单编辑",
                },
            },
            {
                path: "/Order/purchaseOrder/send_order_view",
                name: "send_order_view",
                component: () => import("../views/order/purchaseOrder/send_order_view"),
                meta: {
                    title: "送货单详情",
                },
            },
            {
                path: "/Order/purchaseOrder/executeDelivery",
                name: "executeDelivery",
                component: () => import("../views/order/purchaseOrder/executeDelivery"),
                meta: {
                    title: "执行出库",
                },
            },
            {
                path: "/Order/purchaseOrder/checkSendOrder",
                name: "checkSendOrder",
                component: () => import("../views/order/purchaseOrder/checkSendOrder"),
                meta: {
                    title: "验收送货单",
                },
            },
            {
                path: "/Order/purchaseOrder/return_bill_menu",
                name: "return_bill_menu",
                component: () =>
                    import("../views/order/purchaseOrder/return_bill_menu"),
                meta: {
                    title: "退货单管理(星杰)",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/purchaseOrder/return_bill_menu_supply",
                name: "return_bill_menu_supply",
                component: () =>
                    import("../views/order/purchaseOrder/return_bill_menu_supply"),
                meta: {
                    title: "退货单管理(供应商)",
                    keepAlive: true,
                },
            },
            {
                path: "/Order/purchaseOrder/purchaseOrderUpdate",
                name: "purchaseOrderUpdate",
                component: () =>
                    import("../views/order/purchaseOrder/purchaseOrderUpdate"),
                meta: {
                    title: "采购订单编辑",
                },
            },
            {
                path: "/Order/purchaseOrder/applyForDelivery",
                name: "applyForDelivery",
                component: () =>
                    import("../views/order/purchaseOrder/applyForDelivery"),
                meta: {
                    title: "采购单申请送货",
                },
            },
            {
                path: "/Order/purchaseOrder/applyForReturn",
                name: "applyForReturn",
                component: () => import("../views/order/purchaseOrder/applyForReturn"),
                meta: {
                    title: "采购单申请退货",
                },
            },
            {
                path: "/Order/purchaseOrder/applyForReturnUpdate",
                name: "applyForReturnUpdate",
                component: () =>
                    import("../views/order/purchaseOrder/applyForReturnUpdate"),
                meta: {
                    title: "编辑退货单",
                },
            },
            {
                path: "/Order/purchaseOrder/backOrderView",
                name: "backOrderView",
                component: () => import("../views/order/purchaseOrder/backOrderView"),
                meta: {
                    title: "退货单详情",
                },
            },
            {
                path: "/Order/purchaseOrder/applyForBalance",
                name: "applyForBalance",
                component: () => import("../views/order/purchaseOrder/applyForBalance"),
                meta: {
                    title: "采购单申请结算",
                },
            },
            {
                path: "/Order/purchaseOrder/purchaseOrderView",
                name: "purchaseOrderView",
                component: () =>
                    import("../views/order/purchaseOrder/purchaseOrderView"),
                meta: {
                    title: "我的采购单详情",
                },
            },
            {
                path: "/Order/sendOrder/backOrder",
                name: "sendOrderBack",
                component: () => import("../views/order/purchaseOrder/sendForReturn"),
                meta: {
                    title: "送货单退货",
                },
            },
            {
                path: "/Order/saleOrder/backOrder",
                name: "saleOrderBack",
                component: () => import("../views/order/purchaseOrder/saleForReturn"),
                meta: {
                    title: "销售单退货",
                },
            },
        ],
    },
    {
        path: "/constructionDesign",
        name: "constructionDesign",
        component: Layout,
        redirect: "/constructionDesign/index",
        children: [
            {
                path: "/constructionDesign/index",
                name: "constructionDesignIndex",
                component: () => import("../views/biz/constructionDesign/index"),
                meta: {
                    title: "深化设计施工图管理",
                    keepAlive: true,
                },
            },
            {
                path: "/constructionDesign/add",
                name: "constructionDesign_add",
                component: () =>
                    import("../views/biz/constructionDesign/form/construction_add"),
                meta: {
                    title: "录入工程图",
                },
            },
            {
                path: "/constructionDesign/grade",
                name: "constructionDesignGrade",
                component: () =>
                    import("../views/biz/constructionDesign/form/constructionGrade"),
                meta: {
                    title: "深化设计施工图评分",
                },
            },
            {
                path: "/questionBank/index",
                name: "questionBank",
                meta: {
                    title: "图纸评分标准题库",
                },
                component: () => import("../views/base/drawingsManagement/questionBank/index")
            },
            {
                path: "/questionDetail",
                name: "questionDetail",
                meta: {
                    title: "图纸评分标准题库详情",
                },
                component: () => import("../views/base/drawingsManagement/questionBank/questionDetail")
            },
            {
                path: "/knowledgeBase/index",
                name: "knowledgeBase",
                meta: {
                    title: "图纸规范知识库",
                },
                component: () => import("../views/base/drawingsManagement/knowledgeBase/index")
            },
            {
                path: "/knowledgeBaseDetail",
                name: "knowledgeBaseDetail",
                meta: {
                    title: "图纸规范知识库文件详情",
                },
                component: () => import("../views/base/drawingsManagement/knowledgeBase/detail")
            },
            {
                path: "/constructionDesign/update",
                name: "constructionDesign_update",
                component: () =>
                    import("../views/biz/constructionDesign/form/construction_add"),
                meta: {
                    title: "修改工程图",
                },
            },
            {
                path: "/constructionDesign/detail",
                name: "constructionDetail",
                component: () =>
                    import("../views/biz/constructionDesign/form/constructionDetail"),
                meta: {
                    title: "工程图详情查看",
                },
            },
        ],
    },
    {
        path: "/houseRegion",
        name: "houseRegion",
        component: Layout,
        redirect: "/houseRegion/index",
        children: [
            {
                path: "/houseRegion/index",
                name: "houseRegionIndex",
                component: () => import("../views/biz/houseRegion/index"),
                meta: {
                    title: "区域基础数据维护",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/budget",
        name: "budget",
        component: Layout,
        redirect: "/budget/index",
        children: [
            {
                path: "/budget/index",
                name: "budgetIndex",
                component: () => import("../views/biz/budget/index"),
                meta: {
                    title: "预算管理",
                    keepAlive: true,
                },
            },
            {
                path: "/budget/detail",
                name: "budgetDetail",
                component: () => import("../views/biz/budget/detail/index"),
                meta: {
                    title: "费率表详情",
                },
            },
            {
                path: "/budget/editBudgetList",
                name: "editBudgetList",
                component: () => import("../views/biz/budget/editList"),
                meta: {
                    title: "费率表列表",
                },
            },
        ],
    },
    {
        path: "/budBudgetTemplate",
        name: "budBudgetTemplate",
        redirect: "/budBudgetTemplate/index",
        component: Layout,
        children: [
            {
                path: "/budBudgetTemplate/index",
                name: "budBudgetTemplateIndex",
                component: () => import("../views/biz/budBudgetTemplate/index"),
                meta: {
                    title: "预算模板（新）",
                    keepAlive: true,
                },
            },
            {
                path: "/budBudgetTemplate/editHouse",
                name: "editHouse",
                component: () => import("../views/biz/budBudgetTemplate/editHouse"),
                meta: {
                    title: "编辑模板项目",
                },
            },
            {
                path: "/budBudgetTemplate/editBudgetCost",
                name: "editBudgetCost",
                component: () => import("../views/biz/budBudgetTemplate/editBudgetCost"),
                meta: {
                    title: "预算费用汇总设置",
                },
            },
            {
                path: "/budBudgetTemplate/budgetExplain",
                name: "budgetExplain",
                component: () => import("../views/biz/budBudgetTemplate/budgetExplain"),
                meta: {
                    title: "预算材料/编制说明",
                },
            },
            {
                path: "/budBudgetTemplate/explainPreview",
                name: "explainPreview",
                component: () => import("../views/biz/budBudgetTemplate/explainPreview"),
                meta: {
                    title: "预算材料/编制说明预览",
                },
            },
            {
                path: "/budBudgetTemplate/quotaAnalysis",
                name: "quotaAnalysis",
                component: () => import("../views/biz/budBudgetTemplate/quotaAnalysis"),
                meta: {
                    title: "定额库工料分析",
                    keepAlive: true
                },
            },
            {
                path: "/budBudgetTemplate/bookAnalysis",
                name: "bookAnalysis",
                component: () => import("../views/biz/budBudgetTemplate/bookAnalysis"),
                meta: {
                    title: "预算书工料分析",
                    keepAlive: true
                },
            },
        ],
    },
    {
        path: "/depthDesign",
        name: "depthDesign",
        component: Layout,
        redirect: "/depthDesign/index",
        children: [
            {
                path: "/depthDesign/index",
                name: "depthDesignIndex",
                component: () => import("../views/biz/depthDesign/index"),
                meta: {
                    title: "方案设计效果图管理",
                    keepAlive: true,
                },
            },
            {
                path: "/depthDesign/add",
                name: "depthDesignAdd",
                component: () =>
                    import("../views/biz/depthDesign/form/add_depthDesign"),
                meta: {
                    title: "上传深化效果图",
                },
            },
            {
                path: "/depthDesign/detail",
                name: "depthDesignDetail",
                component: () =>
                    import("../views/biz/depthDesign/form/depthDesignDetail"),
                meta: {
                    title: "方案设计详情查看",
                },
            },
        ],
    },
    {
        path: "/measure",
        name: "measure",
        component: Layout,
        redirect: "/measure/index",
        children: [
            {
                path: "/measure/index",
                name: "measureIndex",
                component: () => import("../views/biz/measure/index"),
                meta: {
                    title: "量房管理",
                    keepAlive: true,
                },
            },
            {
                path: "/measure/entering",
                name: "measure_entering",
                component: () => import("../views/biz/measure/form/entering1"),
                meta: {
                    title: "录入量房数据",
                },
            },
            {
                path: "/measure/log",
                name: "measure_log",
                component: () => import("../views/biz/measure/form/log"),
                meta: {
                    title: "量房修改日志",
                },
            },
            {
                path: "/measure/detail",
                name: "measure_detail",
                component: () => import("../views/biz/measure/form/showView"),
                meta: {
                    title: "量房数据详情",
                },
            },
        ],
    },
    {
        path: "/baseContract",
        name: "baseContract",
        component: Layout,
        redirect: "/baseContract/index",
        children: [
            {
                path: "/baseContract/index",
                name: "baseContractIndex",
                component: () => import("../views/contract/baseContract/index"),
                meta: {
                    title: "基装合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/baseContract/select",
                name: "baseContract_select",
                component: () =>
                    import("../views/contract/baseContract/form/select_customer_info"),
                meta: {
                    title: "选择客户信息",
                },
            },
            {
                path: "/baseContract/add",
                name: "baseContract_add",
                component: () => import("../views/contract/baseContract/form/add"),
                meta: {
                    title: "基装合同编辑",
                },
            },
            {
                path: "/baseContract/reset",
                name: "baseContract_reset",
                component: () =>
                    import("../views/contract/baseContract/form/update_contract_people"),
                meta: {
                    title: "修改基装合同人员信息",
                },
            },
            {
                path: "/baseContract/detail",
                name: "baseContract_detail",
                component: () => import("../views/contract/baseContract/form/detail"),
                meta: {
                    title: "基装合同详情",
                },
            },
            {
                path: "/baseContract/log",
                name: "baseContract_log",
                component: () => import("../views/contract/baseContract/form/log"),
                meta: {
                    title: "基装合同修改日志",
                },
            },
        ],
    },
    {
        path: "/designContract",
        name: "designContract",
        component: Layout,
        redirect: "/designContract/index",
        children: [
            {
                path: "/contract/labour/index",
                name: "labourContract",
                component: () => import("../views/contract/labourContract/index"),
                meta: {
                    title: "劳务合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/contract/labour/select",
                name: "labourContractSelect",
                component: () =>
                    import("../views/contract/labourContract/form/select_case_info"),
                meta: {
                    title: "选择项目信息",
                },
            },
            {
                path: "/contract/labour/add",
                name: "labourContractAdd",
                component: () => import("../views/contract/labourContract/form/add"),
                meta: {
                    title: "新增/修改劳务合同",
                },
            },
        ],
    },
    {
        path: "/softDesignContract",
        name: "softDesignContract_index",
        component: Layout,
        redirect: "/softDesignContract/index",
        children: [
            {
                path: "/softDesignContract/index",
                name: "softDesignContractIndex",
                component: () => import("../views/contract/softDesignContract/index"),
                meta: {
                    title: "软装设计合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/softDesignContract/add",
                name: "softDesignContract_add",
                component: () =>
                    import(
                        "../views/contract/softDesignContract/form/add_contract_design"
                        ),
                meta: {
                    title: "创建软装设计合同",
                },
            },
            {
                path: "/softDesignContract/edit",
                name: "softDesignContract_edit",
                component: () =>
                    import(
                        "../views/contract/softDesignContract/form/add_contract_design"
                        ),
                meta: {
                    title: "修改软装设计合同",
                },
            },
            {
                path: "/softDesignContract/reset",
                name: "softDesignContract_reset",
                component: () =>
                    import(
                        "../views/contract/softDesignContract/form/add_contract_design_reset"
                        ),
                meta: {
                    title: "修改合同合作人员信息",
                },
            },
            {
                path: "/softDesignContract/select",
                name: "softDesignContract_select",
                component: () =>
                    import(
                        "../views/contract/softDesignContract/form/select_customer_info"
                        ),
                meta: {
                    title: "选择客户信息",
                },
            },
            {
                path: "/softDesignContract/detail",
                name: "softDesignContract_detail",
                component: () =>
                    import(
                        "../views/contract/softDesignContract/form/contract_design_detail"
                        ),
                meta: {
                    title: "软装设计合同详情",
                },
            },
            {
                path: "/softDesignContract/super",
                name: "softDesignContract_super",
                component: () =>
                    import(
                        "../views/contract/softDesignContract/form/super_contract_design"
                        ),
                meta: {
                    title: "超级用户修改软装设计合同",
                },
            },
            {
                path: "/softDesignContract/log",
                name: "softDesignContract_log",
                component: () => import("../views/contract/baseContract/form/log"),
                meta: {
                    title: "软装设计合同修改日志",
                },
            },
        ],
    },
    {
        path: "/designContract",
        name: "designContract_Index",
        component: Layout,
        redirect: "/designContract/index",
        children: [
            {
                path: "/designContract/index",
                name: "designContract_index",
                component: () => import("../views/contract/designContract/index"),
                meta: {
                    title: "设计合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/designContract/add",
                name: "designContract_add",
                component: () =>
                    import("../views/contract/designContract/form/add_contract_design"),
                meta: {
                    title: "创建设计合同",
                },
            },
            {
                path: "/designContract/edit",
                name: "designContract_edit",
                component: () =>
                    import("../views/contract/designContract/form/add_contract_design"),
                meta: {
                    title: "修改设计合同",
                },
            },
            {
                path: "/designContract/reset",
                name: "designContract_reset",
                component: () =>
                    import(
                        "../views/contract/designContract/form/update_contract_people"
                        ),
                meta: {
                    title: "修改设计合同人员信息",
                },
            },
            {
                path: "/designContract/super",
                name: "designContract_super",
                component: () =>
                    import("../views/contract/designContract/form/super_contract_design"),
                meta: {
                    title: "超级用户修改设计合同",
                },
            },
            {
                path: "/designContract/detail",
                name: "designContract_detail",
                component: () =>
                    import(
                        "../views/contract/designContract/form/contract_design_detail"
                        ),
                meta: {
                    title: "设计合同详情",
                },
            },
            {
                path: "/designContract/select",
                name: "designContract_select",
                component: () =>
                    import("../views/contract/designContract/form/select_customer_info"),
                meta: {
                    title: "选择客户信息",
                },
            },
            {
                path: "/designContract/log",
                name: "designContract_log",
                component: () => import("../views/contract/baseContract/form/log"),
                meta: {
                    title: "设计合同修改日志",
                },
            },
            {
                path: "/contract/design/stopAgreement",
                name: "contract_design_stopAgreement",
                component: () =>
                    import("../views/contract/designContract/form/design_stop_agreement"),
                meta: {
                    title: "设计合同终止协议",
                },
            },
            {
                path: "/contract/base/stopAgreement",
                name: "contract_base_stopAgreement",
                component: () =>
                    import("../views/contract/baseContract/form/base_stop_agreement"),
                meta: {
                    title: "基装合同终止协议",
                },
            },
        ],
    },
    {
        path: "/intentionContract",
        name: "intentionContractIndex",
        component: Layout,
        redirect: "/intentionContract/index",
        children: [
            {
                path: "/intentionContract/index",
                name: "intentionContract",
                component: () => import("../views/contract/intentionContract/index"),
                meta: {
                    title: "意向合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/intentionContract/select",
                name: "intentionContract_select",
                component: () =>
                    import(
                        "../views/contract/intentionContract/form/select_customer_info"
                        ),
                meta: {
                    title: "选择客户信息",
                },
            },
            {
                path: "/intentionContract/add",
                name: "intentionContract_add",
                component: () =>
                    import(
                        "../views/contract/intentionContract/form/add_intention_contract"
                        ),
                meta: {
                    title: "创建意向协议",
                },
            },
            {
                path: "/intentionContract/edit",
                name: "intentionContract_edit",
                component: () =>
                    import(
                        "../views/contract/intentionContract/form/add_intention_contract"
                        ),
                meta: {
                    title: "修改意向协议",
                },
            },
            {
                path: "/intentionContract/detail",
                name: "intentionContract_detail",
                component: () =>
                    import(
                        "../views/contract/intentionContract/form/contract_intention_detail"
                        ),
                meta: {
                    title: "意向合同详情",
                },
            },
            {
                path: "/intentionContract/log",
                name: "intentionContract_log",
                component: () => import("../views/contract/baseContract/form/log"),
                meta: {
                    title: "意向合同修改日志",
                },
            },
        ],
    },
    {
        path: "/materialContract",
        name: "materialContract",
        component: Layout,
        redirect: "/materialContract/index",
        children: [
            {
                path: "/materialContract/index",
                name: "materialContractIndex",
                component: () => import("../views/contract/materialContract/index"),
                meta: {
                    title: "材料合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/materialContract/select",
                name: "materialContract_select",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/select_customer_info"
                        ),
                meta: {
                    title: "选择客户信息",
                },
            },
            //主材类别
            {
                path: "/materialContract/add",
                name: "materialContract_add",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/add_contract_material"
                        ),
                meta: {
                    title: "材料合同新增",
                },
            },
            //提飒、俏德用
            {
                path: "/materialContract/addOther",
                name: "materialContract_addOther",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/add_contract_material_other"
                        ),
                meta: {
                    title: "材料合同新增",
                },
            },
            {
                path: "/materialContract/edit",
                name: "materialContract_edit",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/add_contract_material"
                        ),
                meta: {
                    title: "材料合同编辑",
                },
            },
            {
                path: "/materialContract/reset",
                name: "materialContract_reset",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/update_contract_people"
                        ),
                meta: {
                    title: "修改合同合作人员信息",
                },
            },
            //提飒、俏德用
            {
                path: "/materialContract/reset_other",
                name: "materialContract_reset_other",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/update_contract_people_other"
                        ),
                meta: {
                    title: "修改合同合作人员信息",
                },
            },
            //提飒、俏德用
            {
                path: "/materialContract/editOther",
                name: "materialContract_editOther",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/add_contract_material_other"
                        ),
                meta: {
                    title: "材料合同编辑",
                },
            },
            {
                path: "/materialContract/detail",
                name: "materialContract_detail",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/contract_material_detail"
                        ),
                meta: {
                    title: "材料合同详情",
                },
            },
            {
                path: "/materialContract/super",
                name: "materialContract_super",
                component: () =>
                    import(
                        "../views/contract/materialContract/form/super_contract_material"
                        ),
                meta: {
                    title: "超级管理员修改材料合同",
                },
            },
            {
                path: "/materialContract/log",
                name: "materialContract_log",
                component: () => import("../views/contract/baseContract/form/log"),
                meta: {
                    title: "材料合同修改日志",
                },
            },
            {
                path: "/materialContract/printRecord",
                name: "materialContract_printRecord",
                component: () => import("../views/contract/baseContract/form/printRecords"),
                meta: {
                    title: "材料合同打印记录",
                },
            },
        ],
    },
    {
        path: "/reformContract",
        name: "reformContract",
        component: Layout,
        redirect: "/reformContract/index",
        children: [
            {
                path: "/reformContract/index",
                name: "reformContractIndex",
                component: () => import("../views/contract/reformContract/index"),
                meta: {
                    title: "拆改建合同管理",
                    keepAlive: true,
                },
            },
            {
                path: "/reformContract/select",
                name: "reformContract_select",
                component: () =>
                    import("../views/contract/reformContract/form/select_customer_info"),
                meta: {
                    title: "选择客户信息",
                },
            },
            {
                path: "/reformContract/add",
                name: "reformContract_add",
                component: () => import("../views/contract/reformContract/form/add"),
                meta: {
                    title: "拆改建合同编辑",
                },
            },
            {
                path: "/reformContract/reset",
                name: "reformContract_reset",
                component: () =>
                    import("../views/contract/reformContract/form/update_contract_people"),
                meta: {
                    title: "修改拆改建合同人员信息",
                },
            },
            {
                path: "/reformContract/detail",
                name: "reformContract_detail",
                component: () => import("../views/contract/reformContract/form/detail"),
                meta: {
                    title: "拆改建合同详情",
                },
            },

        ],
    },





    {
        path: "/materialContract/printFirst",
        name: "materialContractPrint",
        component: () =>
            import(
                "../views/contract/materialContract/form/material_print_first_stage"
                ),
        meta: {
            title: "打印",
        },
    },
    {
        path: "/myCustomer",
        name: "myCustomer",
        component: Layout,
        redirect: "/myCustomer/index",
        children: [
            {
                path: "/myCustomer/index",
                name: "myCustomerIndex",
                component: () => import("../views/biz/myCustomer/index"),
                meta: {
                    title: "我的客户",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/orderService",
        name: "orderService",
        component: Layout,
        redirect: "/orderService/index",
        children: [
            {
                path: "/orderService/index",
                name: "orderServiceIndex",
                component: () => import("../views/biz/orderService/index"),
                meta: {
                    title: "服务订单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/orderService/detail",
                name: "orderService_detail",
                component: () => import("../views/biz/orderService/form/orderLife"),
                meta: {
                    title: "服务订单详情",
                },
            },
            {
                path: "/orderService/edit",
                name: "orderService_edit",
                component: () => import("../views/biz/orderService/form/edit"),
                meta: {
                    title: "修改服务单",
                },
            },
            {
                path: "/orderService/add",
                name: "orderService_add",
                component: () => import("../views/biz/orderService/form/add"),
                meta: {
                    title: "新增服务单",
                },
            },
            {
                path: "/orderService/change",
                name: "orderService_change",
                component: () => import("../views/biz/orderService/form/change"),
                meta: {
                    title: "转单/委派",
                },
            },
        ],
    },
    {
        path: "/bizTagConfig",
        name: "bizTagConfig",
        component: Layout,
        redirect: "/bizTagConfig/index",
        children: [
            {
                path: "/bizTagConfig/index",
                name: "bizTagConfigIndex",
                component: () => import("../views/biz/bizTagConfig/index"),
                meta: {
                    title: "服务客户标签",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/orderServiceIsStop",
        name: "orderServiceIsStop",
        component: Layout,
        redirect: "/orderService/indexIsStop",
        children: [
            {
                path: "/orderService/indexIsStop",
                name: "orderServiceIndexIsStop",
                component: () => import("../views/biz/orderService/indexIsStop"),
                meta: {
                    title: "已终止服务订单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/orderService/detail",
                name: "orderService_detail_form",
                component: () => import("../views/biz/orderService/form/orderLife"),
                meta: {
                    title: "服务订单详情",
                },
            },
            {
                path: "/orderService/edit",
                name: "orderService_edit_form",
                component: () => import("../views/biz/orderService/form/edit"),
                meta: {
                    title: "修改服务单",
                },
            },
            {
                path: "/orderService/editOrderService",
                name: "orderService_editOrderService",
                component: () =>
                    import("../views/biz/orderService/form/editOrderService"),
                meta: {
                    title: "修改服务单",
                },
            },
            {
                path: "/orderService/change",
                name: "orderService_change_form",
                component: () => import("../views/biz/orderService/form/change"),
                meta: {
                    title: "转单",
                },
            },
        ],
    },
    {
        path: "/remind",
        name: "remind",
        component: Layout,
        redirect: "/remind/index",
        children: [
            {
                path: "/remind/index",
                name: "remindIndex",
                component: () => import("../views/biz/remind/index"),
                meta: {
                    title: "商务服务提醒设置",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/rebateFiscalYear",
        name: "rebateFiscalYear",
        component: Layout,
        redirect: "/remind/index",
        children: [
            {
                path: "/rebateFiscalYear/index",
                name: "rebateFiscal",
                component: () => import("../views/biz/rebateFiscalYear/index"),
                meta: {
                    title: "财年维护",
                    keepAlive: true,
                },
            },
            {
                path: "/rebateFiscalYear/add",
                name: "rebateFiscalAdd",
                component: () => import("../views/biz/rebateFiscalYear/add"),
                meta: {
                    title: "新增财年折算",
                },
            },
            {
                path: "/rebateFiscalYear/edit",
                name: "rebateFiscalEdit",
                component: () => import("../views/biz/rebateFiscalYear/edit"),
                meta: {
                    title: "修改财年折算",
                },
            },
        ],
    },
    {
        path: "/rebateReformYear",
        name: "rebateReformYear",
        component: Layout,
        redirect: "/remind/index",
        children: [
            {
                path: "/rebateReformYear/index",
                name: "rebateReform",
                component: () => import("../views/biz/rebateReformYear/index"),
                meta: {
                    title: "拆改建财年维护",
                    keepAlive: true,
                },
            },
            {
                path: "/rebateReformYear/add",
                name: "rebateReformAdd",
                component: () => import("../views/biz/rebateReformYear/add"),
                meta: {
                    title: "新增拆改建财年折算",
                },
            },
            {
                path: "/rebateReformYear/edit",
                name: "rebateReformEdit",
                component: () => import("../views/biz/rebateReformYear/edit"),
                meta: {
                    title: "修改拆改建财年折算",
                },
            },
        ],
    },
    {
        path: "/branchPriceCoefficient",
        name: "branchPriceCoefficient",
        component: Layout,
        redirect: "/branchPriceCoefficient/index",
        children: [
            {
                path: "/branchPriceCoefficient/index",
                name: "branchPriceCoefficientIndex",
                component: () => import("../views/biz/branchPriceCoefficient/index"),
                meta: {
                    title: "分公司采购价系数维护",
                    keepAlive: true,
                },
            },
            {
                path: "/branchPriceCoefficient/add",
                name: "branchPriceCoefficientAdd",
                component: () => import("../views/biz/branchPriceCoefficient/add"),
                meta: {
                    title: "新增分公司采购价系数",
                },
            },
            {
                path: "/branchPriceCoefficient/edit",
                name: "branchPriceCoefficientEdit",
                component: () => import("../views/biz/branchPriceCoefficient/edit"),
                meta: {
                    title: "修改分公司采购价系数",
                },
            },
        ],
    },
    {
        path: "/bizNode",
        name: "bizNode",
        component: Layout,
        redirect: "/node/index",
        children: [
            {
                path: "/node/nodePolicyPaper",
                name: "nodePolicyPaper",
                component: () => import("../views/node/nodePolicyPaper"),
                meta: {
                    title: "节点管控指导文件管理",
                },
            },
            {
                path: "/remindTemplate/index",
                name: "remindTemplate",
                component: () => import("../views/node/remindTemplate/index"),
                meta: {
                    title: "提醒模板",
                    keepAlive: true,
                },
            },
            {
                path: "/bizNodeApplicableRules/index",
                name: "bizNodeApplicableRules",
                component: () => import("../views/node/bizNodeApplicableRules/index"),
                meta: {
                    title: "节点适配",
                    keepAlive: true,
                },
            },
            {
                path: "/nodeTemplate/index",
                name: "nodeTemplate",
                component: () => import("../views/node/nodeTemplate/index"),
                meta: {
                    title: "节点管控设置",
                    keepAlive: true,
                },
            },
            {
                path: "/nodeTemplate/detail",
                name: "nodeTemplateDetail",
                component: () => import("../views/node/nodeTemplate/detail/index"),
                meta: {
                    title: "模板详情",
                    keepAlive: true,
                },
            },
            {
                path: "/implementationDetails",
                name: "implementationDetails",
                component: () =>
                    import("../views/node/bizNode/components/implementationDetails"),
                meta: {
                    title: "节点执行详情",
                    keepAlive: true,
                },
            },
            {
                path: "/addNewNode/index",
                name: "addNewNode",
                component: () => import("../views/node/addNewNode/index"),
                meta: {
                    title: "新增节点",
                    keepAlive: true,
                },
            },
            {
                path: "/updateNode/index",
                name: "updateNode",
                component: () => import("../views/node/updateNode/index"),
                meta: {
                    title: "修改节点",
                    keepAlive: true,
                },
            },
            {
                path: "/bizNode/index",
                name: "bizNodeIndex",
                component: () => import("../views/node/bizNode/index"),
                meta: {
                    title: "节点管控管理",
                    keepAlive: true,
                },
            },
            {
                path: "/bizNode/history",
                name: "nodeHistory",
                component: () =>
                    import("../views/node/bizNode/components/historyDetails"),
                meta: {
                    title: "节点历史",
                    keepAlive: true,
                },
            },
            {
                path: "/bizNode/execute",
                name: "execute",
                component: () => import("../views/node/bizNode/execute/index"),
                meta: {
                    title: "八部执行",
                    keepAlive: true,
                },
            },
            {
                path: "/bizNode/executeNine",
                name: "executeNine",
                component: () => import("../views/node/bizNode/execute/indexNine"),
                meta: {
                    title: "九式执行",
                    keepAlive: true,
                },
            },
            {
                path: "/nodeForm/singleEight",
                name: "singleEightForm",
                component: () => import("../views/node/nodeForm/singleEightForm"),
                meta: {
                    title: "八部单项目报表",
                    keepAlive: true,
                },
            },
            {
                path: "/nodeForm/singleNine",
                name: "singleNineForm",
                component: () => import("../views/node/nodeForm/singleNineForm"),
                meta: {
                    title: "九式单项目报表",
                    keepAlive: true,
                },
            },
            {
                path: "/nodeForm/multiEight",
                name: "multiEightForm",
                component: () => import("../views/node/nodeForm/multiEightForm"),
                meta: {
                    title: "八部多项目报表",
                    keepAlive: true,
                },
            },
            {
                path: "/nodeForm/multiNine",
                name: "multiNineForm",
                component: () => import("../views/node/nodeForm/multiNineForm"),
                meta: {
                    title: "九式多项目报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/question",
        name: "question",
        component: Layout,
        redirect: "/question",
        children: [
            {
                path: "/question/index",
                name: "questionIndex",
                component: () => import("../views/question/index"),
                meta: {
                    title: "问卷调查报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/atjiaApp",
        name: "atjiaApp",
        component: Layout,
        redirect: "/atjiaApp",
        children: [
            {
                path: "/atjia/report",
                name: "atjiaReport",
                component: () => import("../views/atjia/atjiaReport/index"),
                meta: {
                    title: "atjia大数据",
                    keepAlive: true,
                },
            },
            {
                path: "/atjia/questionnaire",
                name: "questionnaireAtjia",
                component: () => import("../views/atjia/atjiaReport/questionnaire"),
                meta: {
                    title: "问卷测评结果",
                    keepAlive: true,
                },
            },
            {
                path: "/atjia/questionnaireProduct",
                name: "questionnaireProduct",
                component: () => import("../views/atjia/atjiaReport/questionnaireProduct"),
                meta: {
                    title: "产品测评结果",
                    keepAlive: true,
                },
            },
            {
                path: "/atjiaApp/index",
                name: "atjiaAppIndex",
                component: () => import("../views/atjia/atjiaApp/index"),
                meta: {
                    title: "运营分析-分公司",
                    keepAlive: true,
                },
            },
            {
                path: "/atjiaApp/loginLog",
                name: "atjiaLoginLogIndex",
                component: () => import("../views/atjia/atjiaLoginLog/index"),
                meta: {
                    title: "客户登录日志",
                    keepAlive: true,
                },
            },
            {
                path: "/atjiaApp/loginDayLog",
                name: "atjiaLoginDayLogIndex",
                component: () => import("../views/atjia/atjiaLoginDayLog/index"),
                meta: {
                    title: "客户日活情况",
                    keepAlive: true,
                },
            },
            {
                path: "/atjiaApp/loginVersionLog",
                name: "atjiaLoginVersionLogIndex",
                component: () => import("../views/atjia/atjiaVersionLog/index"),
                meta: {
                    title: "版本更新情况",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/atjiaAccessLog",
        name: "atjiaAccessLog",
        component: Layout,
        redirect: "/atjiaAccessLog",
        children: [
            {
                path: "/atjiaAccessLog/index",
                name: "atjiaAccessLogIndex",
                component: () => import("../views/atjia/atjiaAccessLog/index"),
                meta: {
                    title: "客户使用明细表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/multipleCustomersAnalysis",
        name: "multipleCustomersAnalysis",
        component: Layout,
        redirect: "/multipleCustomersAnalysis",
        children: [
            {
                path: "/multipleCustomersAnalysis/index",
                name: "multipleCustomersAnalysisIndex",
                component: () =>
                    import("../views/atjia/multipleCustomersAnalysis/index"),
                meta: {
                    title: "多客户浏览统计",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/atjiaOrderAccessLogDay",
        name: "atjiaOrderAccessLogDay",
        component: Layout,
        redirect: "/atjiaOrderAccessLogDay",
        children: [
            {
                path: "/atjiaOrderAccessLogDay/index",
                name: "atjiaOrderAccessLogDayIndex",
                component: () => import("../views/atjia/atjiaOrderAccessLogDay/index"),
                meta: {
                    title: "客户使用统计表",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/finance",
        name: "financeIndex",
        component: Layout,
        redirect: "/finance/index",
        children: [
            {
                path: "/finance/addFinance",
                name: "addFinance",
                component: () =>
                    import("../views/finance/financeManage/link/addFinance"),
                meta: {
                    title: "新增客户收款单",
                },
            },
            {
                path: "/finance/addTransferFinance",
                name: "addTransferFinance",
                component: () =>
                    import("../views/finance/financeManage/link/addTransferFinance"),
                meta: {
                    title: "新增客户转款单",
                },
            },
            {
                path: "/finance/addBusiFinance",
                name: "addBusiFinance",
                component: () =>
                    import("../views/finance/financeManage/link/addBusiFinance"),
                meta: {
                    title: "新增供应商收款单",
                },
            },
        ],
    },
    {
        path: "/contractMaterialSettle",
        name: "contractMaterialSettle",
        component: Layout,
        redirect: "/contractMaterialSettle/index",
        children: [
            {
                path: "/contractMaterialSettle/index",
                name: "contractMaterialSettleIndex",
                component: () =>
                    import("../views/biz/settleCenter/contractMaterialSettle/index"),
                meta: {
                    title: "材料收款结算",
                    keepAlive: true,
                },
            },
            {
                path: "/contractMaterialSettle/settlement",
                name: "settlementReceivables",
                component: () =>
                    import("../views/biz/settleCenter/contractMaterialSettle/settlement"),
                meta: {
                    title: "结算详情",
                },
            },
        ],
    },
    {
        path: "/settleCenterReport",
        name: "settleCenterReport",
        component: Layout,
        redirect: "/settleCenterReport/index",
        children: [
            {
                path: "/settleCenterReport/index",
                name: "settleCenterReportIndex",
                component: () => import("../views/biz/settleCenter/report/index"),
                meta: {
                    title: "结算中心报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/purchaseStatistics",
        name: "purchaseStatistics",
        component: Layout,
        redirect: "/purchaseStatistics/index",
        children: [
            {
                path: "/purchaseStatistics/index",
                name: "purchaseStatisticsIndex",
                component: () =>
                    import("../views/biz/settleCenter/purchaseStatistics/index"),
                meta: {
                    title: "材料统计表",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/financeReport",
        name: "financeReport",
        component: Layout,
        redirect: "/financeReport/index",
        children: [
            {
                path: "/foreseeProfit/index",
                name: "foreseeProfit",
                component: () =>
                    import("../views/finance/reportForms/foreseeProfit/index"),
                meta: {
                    title: "预见利润表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/supplierReceivables",
        name: "supplierReceivables",
        component: Layout,
        redirect: "/supplierReceivables/index",
        children: [
            {
                path: "/supplierReceivables/index",
                name: "supplierReceivablesIndex",
                component: () =>
                    import("../views/biz/settleCenter/financeSupplierReceivables/index"),
                meta: {
                    title: "供应商收款表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/rebateSettle",
        name: "rebateSettle",
        component: Layout,
        redirect: "/rebateSettle/index",
        children: [
            {
                path: "/rebateSettle/index",
                name: "rebateSettleIndex",
                component: () => import("../views/biz/settleCenter/rebateSettle/index"),
                meta: {
                    title: "返利订单收款结算",
                    keepAlive: true,
                },
            },
            {
                path: "/rebateSettle/settlement",
                name: "settlementRebateReceivables",
                component: () =>
                    import("../views/biz/settleCenter/rebateSettle/settlement"),
                meta: {
                    title: "结算详情",
                },
            },
        ],
    },
    {
        path: "/projectManagerExamine",
        name: "projectManagerExamine",
        component: Layout,
        redirect: "/projectManagerExamine/index",
        children: [
            {
                path: "/projectManagerExamine/index",
                name: "projectManagerExamineIndex",
                component: () =>
                    import("../views/biz/projectReport/projectManagerExamine/index"),
                meta: {
                    title: "项目经理考核",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/midService",
        name: "midService",
        component: Layout,
        redirect: "/midService/index",
        children: [
            {
                path: "/midService/index",
                name: "midServiceIndex",
                component: () => import("../views/biz/mid/service/index"),
                meta: {
                    title: "服务单产值中间表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/base",
        name: "baseAll",
        component: Layout,
        redirect: "/base/index",
        children: [
            {
                path: "/base/index",
                name: "baseIndex",
                component: () => import("../views/biz/settleCenter/base/index"),
                meta: {
                    title: "基装收款",
                    keepAlive: true,
                },
            },
            {
                path: "/base/settlement",
                name: "settlement",
                component: () => import("../views/biz/settleCenter/base/settlement"),
                meta: {
                    title: "基装收款结算",
                },
            },
            {
                path: "/base/customer/settlement",
                name: "customer",
                component: () =>
                    import("../views/biz/settleCenter/base/customer/settlement"),
                meta: {
                    title: "客户结算-基装",
                },
            },
        ],
    },
    {
        path: "/design",
        name: "design",
        component: Layout,
        redirect: "/design/index",
        children: [
            {
                path: "/design/index",
                name: "designIndex",
                component: () => import("../views/biz/settleCenter/design/index"),
                meta: {
                    title: "设计收款",
                    keepAlive: true,
                },
            },
            {
                path: "/design/settlement",
                name: "settlementDesign",
                component: () => import("../views/biz/settleCenter/design/settlement"),
                meta: {
                    title: "设计收款结算",
                },
            },
        ],
    },
    {
        path: "/midService",
        name: "midService_index",
        component: Layout,
        redirect: "/midService/index",
        children: [
            {
                path: "/midService/index",
                name: "midService_mid_index",
                component: () => import("../views/biz/mid/service/index"),
                meta: {
                    title: "服务单产值中间表",
                },
            },
        ],
    },
    {
        path: "/midBase",
        name: "midBase",
        component: Layout,
        redirect: "/midBase/index",
        children: [
            {
                path: "/midBase/index",
                name: "midBaseIndex",
                component: () => import("../views/biz/mid/base/index"),
                meta: {
                    title: "基装合同产值中间表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/midScrap",
        name: "midScrap",
        component: Layout,
        redirect: "/midScrap/index",
        children: [
            {
                path: "/midScrap/index",
                name: "midScrapIndex",
                component: () => import("../views/biz/mid/scrap/index"),
                meta: {
                    title: "废单产值中间表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/midDesign",
        name: "midDesign",
        component: Layout,
        redirect: "/midDesign/index",
        children: [
            {
                path: "/midDesign/index",
                name: "midDesignIndex",
                component: () => import("../views/biz/mid/design/index"),
                meta: {
                    title: "设计合同产值中间表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/midIntention",
        name: "midIntention",
        component: Layout,
        redirect: "/midIntention/index",
        children: [
            {
                path: "/midIntention/index",
                name: "midIntentionIndex",
                component: () => import("../views/biz/mid/intention/index"),
                meta: {
                    title: "意向合同产值中间表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/midMeasure",
        name: "midMeasure",
        component: Layout,
        redirect: "/midMeasure/index",
        children: [
            {
                path: "/midMeasure/index",
                name: "midMeasureIndex",
                component: () => import("../views/biz/mid/measure/index"),
                meta: {
                    title: "量房产值中间表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/outputValue",
        name: "outputValue",
        component: Layout,
        redirect: "/outputValue/index",
        children: [
            {
                path: "/outputValue/index",
                name: "outputValueIndex",
                component: () => import("../views/biz/mid/receive/index"),
                meta: {
                    title: "实收产值明细表",
                    keepAlive: true,
                },
            },
            {
                path: "/outputValue/add",
                name: "addOutputValue",
                component: () => import("../views/biz/mid/receive/add"),
                meta: {
                    title: "新增或修改产值",
                },
            },
        ],
    },
    {
        path: "/outputRecord",
        name: "outputRecord",
        component: Layout,
        redirect: "/outuptRecord/index",
        children: [
            {
                path: "/outputRecord/index",
                name: "outputRecordIndex",
                component: () => import("../views/reportDetail/contractOutputDetail/index"),
                meta: {
                    title: "合同产值履历",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/dynamicHouseDelivery",
        name: "dynamicHouseDelivery",
        component: Layout,
        redirect: "/dynamic/houseDelivery",
        children: [
            {
                path: "/dynamic/houseDelivery",
                name: "dynamicHouseDeliveryIndex",
                component: () => import("../views/reportDetail/dynamicHouseDelivery/index"),
                meta: {
                    title: "动态交房目标达成",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/outputCollectValue",
        name: "outputCollectValue",
        component: Layout,
        redirect: "/outputCollectValue/index",
        children: [
            {
                path: "/outputCollectValue/index",
                name: "outputCollectValueIndex",
                component: () => import("../views/biz/mid/output/index"),
                meta: {
                    title: "实收产值表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/cusAnalysis",
        name: "cusAnalysis",
        component: Layout,
        redirect: "/cusAnalysis/index",
        children: [
            {
                path: "/cusAnalysis/index",
                name: "cusAnalysisIndex",
                component: () => import("../views/biz/mid/customer/index"),
                meta: {
                    title: "客户分析表",
                    keepAlive: true,
                },
            },
            {
                path: "/cusAnalysis/indexDetail",
                name: "indexDetail",
                component: () => import("../views/biz/mid/customer/indexDetail"),
                meta: {
                    title: "客户分析表详情",
                },
            },
        ],
    },
    {
        path: "/vChangeLedger",
        name: "vChangeLedger",
        component: Layout,
        redirect: "/vChangeLedger/index",
        children: [
            {
                path: "/vChangeLedger/index",
                name: "vChangeLedgerIndex",
                component: () =>
                    import("../views/project/reportView/changeLedger/index"),
                meta: {
                    title: "变更台账表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/vProjOutTreasuryDetail",
        name: "vProjOutTreasuryDetail",
        component: Layout,
        redirect: "/vProjOutTreasuryDetail/index",
        children: [
            {
                path: "/vProjOutTreasuryDetail/index",
                name: "vProjOutTreasuryDetailIndex",
                component: () =>
                    import("../views/project/reportView/outTreasury/index"),
                meta: {
                    title: "阶段辅材出库明细",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/houseFinance",
        name: "houseFinance",
        component: Layout,
        redirect: "/houseFinance/index",
        children: [
            {
                path: "/houseFinance/index",
                name: "houseFinanceIndex",
                component: () =>
                    import("../views/project/reportView/houseFinance/index"),
                meta: {
                    title: "交房交款达成情况",
                },
            },
        ],
    },
    {
        path: "/auxiliary",
        name: "auxiliary",
        component: Layout,
        redirect: "/auxiliaryMaterials/index",
        children: [
            {
                path: "/auxiliaryMaterials/applyAndOut",
                name: "auxiliaryMaterials",
                component: () => import("../views/project/auxiliaryAndOut/index"),
                meta: {
                    title: " 辅材申购与出库单报表",
                },
            },
        ],
    },
    {
        path: "/report",
        name: "report",
        component: Layout,
        redirect: "/report/orderOffer",
        children: [
            {
                path: "/report/orderOffer",
                name: "orderOffer",
                component: () => import("../views/reportDetail/index"),
                meta: {
                    title: "报价单报表",
                },
            },
        ],
    },
    {
        path: "/report",
        name: "reportProjInfo",
        component: Layout,
        redirect: "/report/projInfo",
        children: [
            {
                path: "/report/projInfo",
                name: "projInfo",
                component: () => import("../views/reportDetail/projInfo"),
                meta: {
                    title: "工程运营报表",
                },
            },
        ],
    },
    {
        path: "/report",
        name: "reportvProjectOPeration",
        component: Layout,
        redirect: "/report/vProjectOperationAnalysis",
        children: [
            {
                path: "/report/vProjectOperationAnalysis",
                name: "vProjectOperationAnalysis",
                component: () =>
                    import("../views/reportDetail/projectOperationAnalysis"),
                meta: {
                    title: "工程运营分析表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/report/projFinanceReceivableMid",
        name: "reportProjFinanceReceivableMid",
        component: Layout,
        redirect: "/report/projFinanceReceivableMid",
        children: [
            {
                path: "/report/projFinanceReceivableMid",
                name: "projFinanceReceivableMid",
                component: () =>
                    import("../views/reportDetail/projFinanceReceivableMid"),
                meta: {
                    title: "应收款报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/payment/complete",
        name: "/paymentComplete",
        component: Layout,
        redirect: "/payment/complete",
        children: [
            {
                path: "/payment/complete",
                name: "paymentComplete",
                component: () =>
                    import("../views/reportDetail/paymentComplete"),
                meta: {
                    title: "交款达成表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/report",
        name: "reportQuality",
        component: Layout,
        redirect: "/report/quality",
        children: [
            {
                path: "/report/quality",
                name: "quality",
                component: () => import("../views/reportDetail/quality"),
                meta: {
                    title: "质检明细报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/report",
        name: "reportCost",
        component: Layout,
        redirect: "/report/cost",
        children: [
            {
                path: "/report/cost",
                name: "cost",
                component: () => import("../views/reportDetail/cost"),
                meta: {
                    title: "成本报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/materialValue",
        name: "materialValue",
        component: Layout,
        redirect: "/materialValue/index",
        children: [
            {
                path: "/materialValue/index",
                name: "materialValueIndex",
                component: () => import("../views/biz/supplyChain/material/index"),
                meta: {
                    title: "材料付款表",
                    keepAlive: true,
                },
            },
        ],
    },
    //商家结算分析表
    {
        path: "/supplyAnalysis",
        name: "supplyAnalysis",
        component: Layout,
        redirect: "/supplyAnalysis/index",
        children: [
            {
                path: "/supplyAnalysis/index",
                name: "supplyAnalysisIndex",
                component: () => import("../views/biz/supplyChain/supply/index"),
                meta: {
                    title: "结算分析表",
                    keepAlive: true,
                },
            },
        ],
    },
    //销售产值报表
    {
        path: "/saleValue",
        name: "saleValue",
        component: Layout,
        redirect: "/saleValue/index",
        children: [
            {
                path: "/saleValue/index",
                name: "saleValueIndex",
                component: () => import("../views/biz/supplyChain/saleValue/index"),
                meta: {
                    title: "销售产值报表",
                    keepAlive: true,
                },
            },
        ],
    },
    //采购产值报表
    {
        path: "/purchaseValue",
        name: "purchaseValue",
        component: Layout,
        redirect: "/purchaseValue/index",
        children: [
            {
                path: "/purchaseValue/index",
                name: "purchaseValueIndex",
                component: () => import("../views/biz/supplyChain/purchase/index"),
                meta: {
                    title: "采购产值报表",
                    keepAlive: true,
                },
            },
            {
                path: "/purchaseValue/parchaseReport",
                name: "parchaseReport",
                component: () =>
                    import("../views/biz/supplyChain/purchase/parchaseReport"),
                meta: {
                    title: "采购单后续单据流程报表",
                    keepAlive: true,
                },
            },
        ],
    },
    //采购严选产值报表
    {
        path: "/purchaseYanXuanValue",
        name: "purchaseYanXuanValue",
        component: Layout,
        redirect: "/purchaseYanXuanValue/index",
        children: [
            {
                path: "/purchaseYanXuanValue/index",
                name: "purchaseYanXuanValueIndex",
                component: () =>
                    import("../views/biz/supplyChain/purchaseYanXuan/index"),
                meta: {
                    title: "采购严选产值报表",
                    keepAlive: true,
                },
            },
        ],
    },
    //供应商基础信息表
    {
        path: "/vBizSupplyInfo",
        name: "vBizSupplyInfo",
        component: Layout,
        redirect: "/vBizSupplyInfo/index",
        children: [
            {
                path: "/vBizSupplyInfo/index",
                name: "vBizSupplyInfoIndex",
                component: () => import("../views/biz/supplyChain/supplyInfo/index"),
                meta: {
                    title: "供应商基础信息表",
                    keepAlive: true,
                },
            },
        ],
    },
    //在建工地分析表
    {
        path: "/bizBuildingAnalysis",
        name: "bizBuildingAnalysis",
        component: Layout,
        redirect: "/bizBuildingAnalysis/index",
        children: [
            {
                path: "/bizBuildingAnalysis/index",
                name: "bizBuildingAnalysisIndex",
                component: () => import("../views/biz/supplyChain/building/index"),
                meta: {
                    title: "在建工地分析表",
                    keepAlive: true,
                },
            },
        ],
    },
    //完工结算明细表
    {
        path: "/completionSettlement",
        name: "completionSettlement",
        component: Layout,
        redirect: "/completionSettlement/index",
        children: [
            {
                path: "/completionSettlement/index",
                name: "completionSettlementIndex",
                component: () =>
                    import("../views/biz/supplyChain/completionSettlement/index"),
                meta: {
                    title: "完工结算明细表",
                    keepAlive: true,
                },
            },
        ],
    },
    //完工结算明细子表
    {
        path: "/completionSettlementDetail",
        name: "completionSettlementDetail",
        component: Layout,
        redirect: "/completionSettlementDetail/index",
        children: [
            {
                path: "/completionSettlementDetail/index",
                name: "completionSettlementDetailIndex",
                component: () =>
                    import("../views/biz/supplyChain/completionSettlementDetail/index"),
                meta: {
                    title: "完工结算明细子表",
                    keepAlive: true,
                },
            },
        ],
    },
    //完工结算分析报表
    {
        path: "/accountReportAnalysis",
        name: "accountReportAnalysis",
        component: Layout,
        redirect: "/accountReportAnalysis/index",
        children: [
            {
                path: "/accountReportAnalysis/index",
                name: "accountReportAnalysisIndex",
                component: () =>
                    import("../views/biz/supplyChain/accountReportAnalysis/index"),
                meta: {
                    title: "完工结算分析报表",
                    keepAlive: true,
                },
            },
        ],
    },

    //材料运营数据
    {
        path: "/materialOperation",
        name: "materialOperation",
        component: Layout,
        redirect: "/materialOperation/index",
        children: [
            {
                path: "/materialOperation/index",
                name: "materialOperationIndex",
                component: () =>
                    import("../views/biz/supplyChain/materialOperation/index"),
                meta: {
                    title: "材料运营数据",
                    keepAlive: true,
                },
            },
        ],
    },
    //材料完工结算分析表
    {
        path: "/materialSettleAnalysis",
        name: "materialSettleAnalysis",
        component: Layout,
        redirect: "/materialSettleAnalysis/index",
        children: [
            {
                path: "/materialSettleAnalysis/index",
                name: "materialSettleAnalysisIndex",
                component: () =>
                    import("../views/biz/supplyChain/materialSettleAnalysis/index"),
                meta: {
                    title: "材料完工结算分析表",
                    keepAlive: true,
                },
            },
        ],
    },
    //年度二三四期款应收报表
    {
        path: "/materialSettleCollection",
        name: "materialSettleCollection",
        component: Layout,
        redirect: "/materialSettleCollection/index",
        children: [
            {
                path: "/materialSettleCollection/index",
                name: "materialSettleCollectionIndex",
                component: () =>
                    import("../views/biz/supplyChain/materialSettleCollection/index"),
                meta: {
                    title: "年度二三四期款应收报表",
                    keepAlive: true,
                },
            },
        ],
    },
    //基装全案数据
    {
        path: "/baseWholeCase",
        name: "baseWholeCase",
        component: Layout,
        redirect: "/baseWholeCase/index",
        children: [
            {
                path: "/baseWholeCase/index",
                name: "baseWholeCaseIndex",
                component: () => import("../views/biz/supplyChain/baseWholeCase/index"),
                meta: {
                    title: "基装全案数据",
                    keepAlive: true,
                },
            },
        ],
    },
    //产品销售达成
    {
        path: "/category",
        name: "baseWholeCaseCategory",
        component: Layout,
        redirect: "/category/index",
        children: [
            {
                path: "/category/index",
                name: "categoryIndex",
                component: () => import("../views/biz/productSalesAchieved/category/index"),
                meta: {
                    title: "产品销售达成",
                    keepAlive: true,
                },
            },
        ],
    },
    //产品采购达成
    {
        path: "/purchasing",
        name: "baseWholeCasePurchase",
        component: Layout,
        redirect: "/purchasing/index",
        children: [
            {
                path: "/purchasing/index",
                name: "purchasingIndex",
                component: () => import("../views/biz/productPurchasing/purchasing/index"),
                meta: {
                    title: "产品采购达成",
                    keepAlive: true,
                },
            },
        ],
    },
    //待选工作项
    {
        path: "/necessary",
        name: "necessaryWorks",
        component: Layout,
        redirect: "/necessary/index",
        children: [
            {
                path: "/necessary/index",
                name: "necessaryWorksIndex",
                component: () =>
                    import("../views/biz/supplyChain/necessaryWorks/index"),
                meta: {
                    title: "待选工作项",
                    keepAlive: true,
                },
            },
        ],
    },

    //材料合同明细表
    {
        path: "/contractMaterialDetail",
        name: "contractMaterialDetail",
        component: Layout,
        redirect: "/contractMaterialDetail/index",
        children: [
            {
                path: "/contractMaterialDetail/index",
                name: "contractMaterialDetailIndex",
                component: () =>
                    import("../views/biz/supplyChain/contractMaterial/index"),
                meta: {
                    title: "材料合同明细表",
                    keepAlive: true,
                },
            },
        ],
    },
    //材料合同明细子表
    {
        path: "/contractMaterialDetailSon",
        name: "contractMaterialDetailSon",
        component: Layout,
        redirect: "/contractMaterialDetailSon/index",
        children: [
            {
                path: "/contractMaterialDetailSon/index",
                name: "contractMaterialDetailSonIndex",
                component: () =>
                    import("../views/biz/supplyChain/contractMaterialDetail/index"),
                meta: {
                    title: "材料合同明细子表",
                    keepAlive: true,
                },
            },
        ],
    },
    //产品合同产值表
    {
        path: "/productContractValue",
        name: "productContractValue",
        component: Layout,
        redirect: "/productContractValue/index",
        children: [
            {
                path: "/productContractValue/index",
                name: "productContractValueIndex",
                component: () =>
                    import("../views/biz/supplyChain/productContractValue/index"),
                meta: {
                    title: "产品合同产值表",
                    keepAlive: true,
                },
            },
        ],
    },
    //产品SKU管理表
    {
        path: "/bizOrderSku",
        name: "bizOrderSku",
        component: Layout,
        redirect: "/bizOrderSku/index",
        children: [
            {
                path: "/bizOrderSku/index",
                name: "bizOrderSkuIndex",
                component: () => import("../views/biz/supplyChain/bizOrderSku/index"),
                meta: {
                    title: "产品SKU管理表",
                    keepAlive: true,
                },
            },
        ],
    },
    //品类明细达成看板
    {
        path: "/supplyChainReachAnalysis",
        name: "supplyChainReachAnalysis",
        component: Layout,
        redirect: "/supplyChainReachAnalysis/index",
        children: [
            {
                path: "/supplyChainReachAnalysis/index",
                name: "supplyChainReachAnalysisIndex",
                component: () => import("../views/biz/supplyChain/reachBoard/index"),
                meta: {
                    title: "采购数据及利润表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/financeTransfer",
        name: "financeTransfer",
        component: Layout,
        redirect: "/financeTransfer/index",
        children: [
            {
                path: "/financeTransfer/index",
                name: "financeTransferIndex",
                component: () =>
                    import("../views/finance/financeManage/component/cusIndexTransfer"),
                meta: {
                    title: "收款管理-客户转款",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/financeBusiness",
        name: "financeBusiness",
        component: Layout,
        redirect: "/financeBusiness/index",
        children: [
            {
                path: "/financeBusiness/index",
                name: "financeBusinessIndex",
                component: () =>
                    import("../views/finance/financeManage/component/busiIndex"),
                meta: {
                    title: "收款管理-供应商收款",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/financeCustomer",
        name: "financeCustomer",
        component: Layout,
        redirect: "/financeCustomer/index",
        children: [
            {
                path: "/financeCustomer/index",
                name: "financeCustomerIndex",
                component: () =>
                    import("../views/finance/financeManage/component/cusIndex"),
                meta: {
                    title: "收款管理-客户收款",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/financeEReceipt",
        name: "financeEReceipt",
        component: Layout,
        redirect: "/financeEReceipt/index",
        children: [
            {
                path: "/financeEReceipt/index",
                name: "EReceiptList",
                component: () =>
                    import("../views/finance/EReceiptManage/index"),
                meta: {
                    title: "收据管理",
                    keepAlive: true,
                },
            },
            {
                path: "/financeEReceipt/add",
                name: "addEReceipt",
                component: () =>
                    import("../views/finance/EReceiptManage/form/addEReceipt.vue"),
                meta: {
                    title: "新增电子收据",
                },
            },
        ],
    },
    {
        path: "/financeAccount",
        name: "financeAccount",
        component: Layout,
        redirect: "/financeAccount/index",
        children: [
            {
                path: "/financeAccount/index",
                name: "financeAccountIndex",
                component: () => import("../views/finance/account/index"),
                meta: {
                    title: "收款账号管理",
                    keepAlive: true,
                },
            },
            {
                path: "/financeAccount/add",
                name: "financeAccountAdd",
                component: () => import("../views/finance/account/form/add"),
                meta: {
                    title: "新增收款账号",
                },
            },
        ],
    },
    {
        path: "/financeInformation",
        name: "financeInformation",
        component: Layout,
        redirect: "/financeInformation/index",
        children: [
            {
                path: "/financeInformation/index",
                name: "financeInformationIndex",
                component: () => import("../views/finance/financeInformation/index"),
                meta: {
                    title: "收款账号配置",
                    keepAlive: true,
                },
            },
            {
                path: "/financeInformation/add",
                name: "financeInformationAdd",
                component: () => import("../views/finance/financeInformation/form/add"),
                meta: {
                    title: "新增收款账号配置",
                },
            },
        ],
    },
    {
        path: "/financeClaim",
        name: "financeClaim",
        component: Layout,
        redirect: "/financeClaim/index",
        children: [
            {
                path: "/financeClaim/index",
                name: "financeClaimIndex",
                component: () => import("../views/finance/claim/index"),
                meta: {
                    title: "收款认领管理",
                    keepAlive: true,
                },
            },
            {
                path: "/financeClaim/add",
                name: "financeClaimAdd",
                component: () => import("../views/finance/claim/form/add"),
                meta: {
                    title: "新增收款认领",
                },
            },
        ],
    },
    {
        path: "/claimManageCashReport",
        name: "claimManageCashReport",
        component: Layout,
        redirect: "/claimManageCashReport/index",
        children: [
            {
                path: "/claimManageCashReport/index",
                name: "claimManageCashReportIndex",
                component: () => import("../views/finance/claimManageCashReport/index"),
                meta: {
                    title: "经营收款表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/handWorkClaimReport",
        name: "handWorkClaimReport",
        component: Layout,
        redirect: "/handWorkClaimReport/index",
        children: [
            {
                path: "/handWorkClaimReport/index",
                name: "Index",
                component: () => import("../views/finance/handWorkClaimReport/index"),
                meta: {
                    title: "手工认领报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/materialPayment",
        name: "materialPayment",
        component: Layout,
        redirect: "/materialPayment/index",
        children: [
            {
                path: "/materialPayment/index",
                name: "materialPaymentIndex",
                component: () => import("../views/finance/materialPayment/index"),
                meta: {
                    title: "材料付款管理",
                    keepAlive: true,
                },
            },
            {
                path: "/materialPayment/add",
                name: "addMaterialPayment",
                component: () =>
                    import("../views/finance/materialPayment/form/addMaterialPayment"),
                meta: {
                    title: "材料付款新增(编辑)",
                },
            },
            {
                path: "/materialPayment/edit",
                name: "editMaterialPayment",
                component: () =>
                    import("../views/finance/materialPayment/form/addMaterialPayment"),
                meta: {
                    title: "材料付款编辑",
                },
            },
            {
                path: "/materialPayment/detail",
                name: "MaterialPaymentDetail",
                component: () =>
                    import(
                        "../views/finance/materialPayment/form/material_payment_detail"
                        ),
                meta: {
                    title: "材料付款详情",
                },
            },
            {
                path: "/materialPayment/supDetail",
                name: "MaterialPaymentSupplierDetail",
                component: () =>
                    import("../views/finance/materialPayment/form/supplier_detail"),
                meta: {
                    title: "材料付款结算详情",
                },
            },
            {
                path: "/supplier/edit",
                name: "MaterialPaymentSupplierEdit",
                component: () =>
                    import("../views/finance/materialPayment/form/supplier_edit"),
                meta: {
                    title: "材料付款结算修改",
                },
            },
        ],
    },
    {
        path: "/receiptAccount",
        name: "receiptAccount",
        component: Layout,
        redirect: "/receiptAccount/index",
        children: [
            {
                path: "/receiptAccount/index",
                name: "receiptAccountIndex",
                component: () => import("../views/finance/receiptAccount/index"),
                meta: {
                    title: "材料付款单账号管理",
                    keepAlive: true,
                },
            },
            {
                path: "/receiptAccount/add",
                name: "receiptAccountAdd",
                component: () => import("../views/finance/receiptAccount/receiptAccountAdd"),
                meta: {
                    title: "新增材料付款单账号",
                },
            },
            {
                path: "/receiptAccount/update",
                name: "receiptAccountUpdate",
                component: () => import("../views/finance/receiptAccount/receiptAccountUpdate"),
                meta: {
                    title: "修改材料付款单账号",
                },
            },
        ],
    },
    {
        path: "/materialPaymentApply",
        name: "materialPaymentApply",
        component: Layout,
        redirect: "/paymentApply/index",
        children: [
            {
                path: "/paymentApply/index",
                name: "paymentApply",
                component: () => import("../views/finance/materialPaymentApply/indexNew"),
                meta: {
                    title: "材料付款申请管理",
                    keepAlive: true,
                },
            },
            {
                path: "/paymentApplyJC/index",
                name: "paymentApplyJC",
                component: () => import("../views/finance/materialPaymentApply/indexNew"),
                meta: {
                    title: "材料付款申请管理(集采)",
                    keepAlive: true,
                },
            },
            {
                path: "/paymentApply/receiptAccount",
                name: "paymentApplyReceiptAccount",
                component: () => import("../views/finance/materialPaymentApply/component/receiptAccount"),
                meta: {
                    title: "选择收款账号",
                    keepAlive: true,
                },
            },
            {
                path: "/paymentApply/detail",
                name: "paymentApplyDetail",
                component: () =>
                    import(
                        "../views/finance/materialPaymentApply/component/detail"
                        ),
                meta: {
                    title: "材料付款申请详情",
                },
            },
        ],
    },
    {
        path: "/order/guarantee",
        name: "guarantee",
        component: Layout,
        redirect: "/order/guarantee/index",
        children: [
            {
                path: "/order/guarantee/index",
                name: "guaranteeIndex",
                component: () => import("../views/order/guarantee/index"),
                meta: {
                    title: "担保单管理",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/projectPayment",
        name: "projectPayment",
        component: Layout,
        redirect: "/projectPayment/index",
        children: [
            {
                path: "/projectPayment/index",
                name: "projectPaymentIndex",
                component: () => import("../views/finance/projectPayment/index"),
                meta: {
                    title: "项目付款管理",
                    keepAlive: true,
                },
            },
            {
                path: "/projectPayment/add",
                name: "addProjectPayment",
                component: () =>
                    import("../views/finance/projectPayment/form/add_project_payment"),
                meta: {
                    title: "项目付款新增",
                },
            },
            {
                path: "/projectPayment/edit",
                name: "editProjectPayment",
                component: () =>
                    import("../views/finance/projectPayment/form/add_project_payment"),
                meta: {
                    title: "项目付款编辑",
                },
            },
            {
                path: "/projectPayment/detail",
                name: "projectPaymentDetail",
                component: () =>
                    import("../views/finance/projectPayment/form/project_payment_detail"),
                meta: {
                    title: "项目付款详情",
                },
            },
            {
                path: "/projectPayment/projDetail",
                name: "projectManagerPaymentDetail",
                component: () =>
                    import("../views/finance/projectPayment/form/project_detail"),
                meta: {
                    title: "项目付款结算详情",
                },
            },
        ],
    },
    {
        path: "/projectPaymentPerson",
        name: "projectPaymentPerson",
        component: Layout,
        redirect: "/projectPaymentPerson/index",
        children: [
            {
                path: "/projectPaymentPerson/index",
                name: "projectPaymentPersonIndex",
                component: () => import("../views/finance/projectPaymentPerson/index"),
                meta: {
                    title: "劳务费管理",
                    keepAlive: true,
                },
            },
            {
                path: "/materialPaymentOrder/index",
                name: "materialPaymentOrder",
                component: () => import("../views/finance/materialPaymentOrder/index"),
                meta: {
                    title: "星侠打款单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/projectPaymentPerson/add",
                name: "addProjectPaymentPerson",
                component: () =>
                    import(
                        "../views/finance/projectPaymentPerson/form/add_project_payment"
                        ),
                meta: {
                    title: "劳务费新增",
                },
            },
            {
                path: "/projectPaymentPerson/edit",
                name: "editProjectPaymentPerson",
                component: () =>
                    import(
                        "../views/finance/projectPaymentPerson/form/add_project_payment"
                        ),
                meta: {
                    title: "劳务费编辑",
                },
            },
            {
                path: "/projectPaymentPerson/editLabor",
                name: "editProjectPaymentPersonLabor",
                component: () =>
                    import(
                        "../views/finance/projectPaymentPerson/form/add_project_payment_labor_edit"
                        ),
                meta: {
                    title: "劳务费修改",
                },
            },
            {
                path: "/projectPaymentPerson/detail",
                name: "projectPaymentDetailPerson",
                component: () =>
                    import(
                        "../views/finance/projectPaymentPerson/form/project_payment_detail"
                        ),
                meta: {
                    title: "劳务费详情",
                },
            },
            {
                path: "/projectPaymentPerson/projDetail",
                name: "projectManagerPaymentPersonDetail",
                component: () =>
                    import("../views/finance/projectPaymentPerson/form/project_detail"),
                meta: {
                    title: "劳务费结算详情",
                },
            },
        ],
    },
    {
        path: "/projectPaymentOther",
        name: "projectPaymentOther",
        component: Layout,
        redirect: "/projectPaymentOther/index",
        children: [
            {
                path: "/projectPaymentOther/index",
                name: "projectPaymentOtherIndex",
                component: () => import("../views/finance/projectPaymentOther/index"),
                meta: {
                    title: "项目费用管理",
                    keepAlive: true,
                },
            },
            {
                path: "/projectPaymentOther/add",
                name: "addprojectPaymentOther",
                component: () =>
                    import(
                        "../views/finance/projectPaymentOther/form/add_project_payment"
                        ),
                meta: {
                    title: "项目费用新增",
                },
            },
            {
                path: "/projectPaymentOther/edit",
                name: "editprojectPaymentOther",
                component: () =>
                    import(
                        "../views/finance/projectPaymentOther/form/add_project_payment"
                        ),
                meta: {
                    title: "项目费用编辑",
                },
            },
            {
                path: "/projectPaymentOther/detail",
                name: "projectPaymentDetailPersonOther",
                component: () =>
                    import(
                        "../views/finance/projectPaymentOther/form/project_payment_detail"
                        ),
                meta: {
                    title: "项目费用详情",
                },
            },
            {
                path: "/projectPaymentOther/projDetail",
                name: "projectManagerPaymentPersonDetailOther",
                component: () =>
                    import("../views/finance/projectPaymentOther/form/project_detail"),
                meta: {
                    title: "项目费用结算详情",
                },
            },
        ],
    },
    {
        path: "/projectPaymentManager",
        name: "projectPaymentManager",
        component: Layout,
        redirect: "/projectPaymentManager/index",
        children: [
            {
                path: "/projectPaymentManager/index",
                name: "projectPaymentManagerIndex",
                component: () => import("../views/finance/projectPaymentManager/index"),
                meta: {
                    title: "项目经理付款管理",
                    keepAlive: true,
                },
            },
            {
                path: "/projectPaymentManager/add",
                name: "addprojectPaymentManager",
                component: () =>
                    import(
                        "../views/finance/projectPaymentManager/form/add_project_payment"
                        ),
                meta: {
                    title: "项目经理付款新增",
                },
            },
            {
                path: "/projectPaymentManager/edit",
                name: "editprojectPaymentManager",
                component: () =>
                    import(
                        "../views/finance/projectPaymentManager/form/add_project_payment"
                        ),
                meta: {
                    title: "项目经理付款编辑",
                },
            },
            {
                path: "/projectPaymentManager/detail",
                name: "projectPaymentDetailPersonManager",
                component: () =>
                    import(
                        "../views/finance/projectPaymentManager/form/project_payment_detail"
                        ),
                meta: {
                    title: "项目经理付款详情",
                },
            },
            {
                path: "/projectPaymentManager/projDetail",
                name: "projectManagerPaymentPersonDetailProj",
                component: () =>
                    import("../views/finance/projectPaymentManager/form/project_detail"),
                meta: {
                    title: "项目经理付款结算详情",
                },
            },
        ],
    },
    {
        path: "/workPackage",
        name: "workPackage",
        component: Layout,
        redirect: "/workPackage/index",
        children: [
            {
                path: "/workPackage/index",
                name: "workPackageIndex",
                component: () => import("../views/process/package/index"),
                meta: {
                    title: "任务包管理",
                    keepAlive: true,
                },
            },
            {
                path: "/workPackage/add",
                name: "workPackageAdd",
                component: () => import("../views/process/package/form/add"),
                meta: {
                    title: "任务包管理新增",
                },
            },
        ],
    },
    {
        path: "/projPlanTemplate",
        name: "projPlanTemplate",
        component: Layout,
        redirect: "/projPlanTemplate/index",
        children: [
            {
                path: "/projPlanTemplate/index",
                name: "projPlanTemplateIndex",
                component: () => import("../views/process/template/index"),
                meta: {
                    title: "计划模板管理",
                    keepAlive: true,
                },
            },
            {
                path: "/projPlanTemplate/add",
                name: "projPlanTemplateAdd",
                component: () => import("../views/process/template/form/add"),
                meta: {
                    title: "计划模板管理新增",
                },
            },
        ],
    },
    {
        path: "/projPlanRemindTemplate",
        name: "projPlanRemindTemplate",
        component: Layout,
        redirect: "/projPlanRemindTemplate/index",
        children: [
            {
                path: "/projPlanRemindTemplate/index",
                name: "projPlanRemindTemplateIndex",
                component: () => import("../views/process/remindTemplate/index"),
                meta: {
                    title: "计划提醒模板管理",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/workpackageCheckManage",
        name: "workpackageCheckManage",
        component: Layout,
        redirect: "/workpackageCheckManage/index",
        children: [
            {
                path: "/workpackageCheckManage/index",
                name: "workpackageCheckManageIndex",
                component: () => import("../views/process/checkManage/index"),
                meta: {
                    title: "检查项管理",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/projectPlan",
        name: "projectPlan",
        component: Layout,
        redirect: "/projectPlan/index",
        children: [
            {
                path: "/projectPlan/index",
                name: "projectProcessPlanIndex",
                component: () => import("../views/process/projectPlan/index"),
                meta: {
                    title: "项目计划管理",
                    keepAlive: true,
                },
            },
            {
                path: "/projectPlan/add",
                name: "projectPlanAdd",
                component: () => import("../views/process/projectPlan/form/add"),
                meta: {
                    title: "项目计划铺排",
                    // keepAlive: true,
                },
            },
            {
                path: "/projectPlan/addRun",
                name: "projectPlanAddRun",
                component: () => import("../views/process/projectPlan/form/addRun"),
                meta: {
                    title: "项目计划铺排/变更",
                    // keepAlive: true,
                },
            },
            {
                path: "/projectPlan/detail",
                name: "projectPlanDetail",
                component: () => import("../views/process/projectPlan/form/detail"),
                meta: {
                    title: "项目计划详情",
                },
            },
            {
                path: "/projectPlan/detailToExecute",
                name: "projectPlanDetailToExecute",
                component: () => import("../views/process/projectPlan/form/detailToExecute"),
                meta: {
                    title: "项目计划执行详情",
                },
            },
            {
                path: "/projectPlan/execute",
                name: "projectPlanExecute",
                component: () => import("../views/process/projectPlan/form/execute"),
                meta: {
                    title: "项目计划执行",
                },
            },
            {
                path: "/projectPlan/viewHistory",
                name: "projectPlanViewHistorye",
                component: () => import("../views/process/projectPlan/form/viewHistory"),
                meta: {
                    title: "项目计划履历",
                },
            },
        ],
    },
    {
        path: "/projectMaterialPlan",
        name: "projectMaterialPlan",
        component: Layout,
        redirect: "/projectMaterialPlan/index",
        children: [
            {
                path: "/projectMaterialPlan/index",
                name: "projectMaterialPlanIndex",
                component: () => import("../views/process/materialPlan/index"),
                meta: {
                    title: "材料甲供/乙供管理列表",
                    keepAlive: true,
                },
            },
            {
                path: "/projectMaterialPlan/update",
                name: "projectMaterialPlanUpdate",
                component: () => import("../views/process/materialPlan/form/update"),
                meta: {
                    title: " 材料供应方维护页面",
                },
            },
            {
                path: "/projectMaterialPlan/detail",
                name: "projectMaterialPlanDetail",
                component: () => import("../views/process/materialPlan/form/detail"),
                meta: {
                    title: " 材料供应方详情",
                },
            },
        ],
    },
    {
        path: "/contractSub",
        name: "contractSub",
        component: Layout,
        redirect: "/contractSubject/index",
        children: [
            {
                path: "/contractSubject/index",
                name: "contractSubIndex",
                component: () => import("../views/biz/contractSubject/index"),
                meta: {
                    title: "维护合同签订主体",
                    keepAlive: true,
                },
            },
            {
                path: "/contractSubject/add",
                name: "contractSubject_add",
                component: () =>
                    import("../views/biz/contractSubject/form/add_contractSub"),
                meta: {
                    title: "维护合同签订主体-新增",
                },
            },
        ],
    },
    {
        path: "/contractTpl",
        name: "contractTpl",
        component: Layout,
        redirect: "/contractTpl/index",
        children: [
            {
                path: "/contractTpl/index",
                name: "contractTplIndex",
                component: () => import("../views/biz/contractTpl/index"),
                meta: {
                    title: "合同字段模板列表",
                    keepAlive: true,
                },
            },
            {
                path: "/contractTpl/add",
                name: "contractTpl_add",
                component: () =>
                    import("../views/biz/contractTpl/form/add_contractTpl"),
                meta: {
                    title: "合同字段模板列表-新增",
                },
            },
            {
                path: "/contractTpl/detail",
                name: "contractTpl_detail",
                component: () =>
                    import("../views/biz/contractTpl/form/detail_contractTpl"),
                meta: {
                    title: "合同字段模板列表-详情",
                },
            },
            {
                path: "/contractTplDetail/add",
                name: "contractTplDetail_add",
                component: () =>
                    import("../views/biz/contractTpl/form/add_contractTplDetail"),
                meta: {
                    title: "新增合同模板字段",
                },
            },
        ],
    },
    {
        path: "/contractReform",
        name: "contractReform",
        component: Layout,
        redirect: "/reformSubject/index",
        children: [
            {
                path: "/reformSubject/index",
                name: "contractReformIndex",
                component: () => import("../views/biz/reformSubject/index"),
                meta: {
                    title: "维护拆改建合同乙方主体",
                    keepAlive: true,
                },
            },
            {
                path: "/reformSubject/add",
                name: "contractReform_add",
                component: () =>
                    import("../views/biz/reformSubject/form/add_contractReform"),
                meta: {
                    title: "维护拆改建合同乙方主体-新增",
                },
            },
        ],
    },

    // 工程报表
    {
        path: "/projectReport",
        name: "projectReport",
        component: Layout,
        redirect: "/projectReport/index",
        children: [
            {
                path: "/introduce/outputValueReach/index",
                name: "outputValueReach",
                component: () => import("../views/project/reportView/introduce/outputValueReach/index"),
                meta: {
                    title: "工程回单达成表",
                    keepAlive: true,
                },
            },
        ],
    },


    {
        path: "/designHouseRegion",
        name: "designHouseRegion",
        component: Layout,
        redirect: "/designHouseRegion/index",
        children: [
            {
                path: "/designHouseRegion/index",
                name: "designHouseRegionIndex",
                component: () => import("../views/biz/designHouseRegion/index"),
                meta: {
                    title: "房屋结构维护管理",
                    keepAlive: true,
                },
            },
            {
                path: "/designHouseRegion/addHouseRegion",
                name: "addHouseRegion",
                component: () =>
                    import("../views/biz/designHouseRegion/form/addHouseRegion"),
                meta: {
                    title: "录入房屋结构",
                },
            },
            {
                path: "/designHouseRegion/addHouseRegionDetail",
                name: "addHouseRegionDetail",
                component: () =>
                    import("../views/biz/designHouseRegion/form/addHouseRegionDetail"),
                meta: {
                    title: "房屋结构详情",
                },
            },
        ],
    },
    {
        path: "/bizOrder",
        name: "bizOrder",
        component: Layout,
        redirect: "/bizOrder/index",
        children: [
            {
                path: "/bizOrder/index",
                name: "bizOrderIndex",
                component: () => import("../views/biz/order/index"),
                meta: {
                    title: "需求订单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/bizOrder/add",
                name: "bizOrderAdd",
                component: () => import("../views/biz/order/form/add"),
                meta: {
                    title: "新增需求订单",
                },
            },
        ],
    },

    //结算管理路由
    {
        path: "/settlementSupplier",
        name: "settlementSupplier",
        component: Layout,
        redirect: "/settlement/index",
        children: [
            {
                path: "/settlement/supplier/index",
                name: "settlementSupplierXingjie",
                component: () => import("../views/settlement/supplier/index"),
                meta: {
                    title: "商家结算(星杰)",
                    keepAlive: true,
                },
            },
            {
                path: "/settlement/supplier/index_supply",
                name: "settlementSupplierIndex",
                component: () => import("../views/settlement/supplier/index_supply"),
                meta: {
                    title: "商家结算(供应商)",
                    keepAlive: true,
                },
            },
            {
                path: "/settlement/supplier/view",
                name: "settlementSupplierView",
                component: () => import("../views/settlement/supplier/view"),
                meta: {
                    title: "商家结算详情",
                },
            },
            {
                path: "/settlement/supplier/update",
                name: "settlementSupplierUpdate",
                component: () => import("../views/settlement/supplier/update"),
                meta: {
                    title: "商家结算编辑",
                },
            },
        ],
    },
    {
        path: "/settlementMaterial",
        name: "settlementMaterial",
        component: Layout,
        redirect: "/settlementMaterial/index",
        children: [
            {
                path: "/settlementMaterial/index",
                name: "settlementMaterialIndex",
                component: () => import("../views/settlement/material/index"),
                meta: {
                    title: "客户结算-材料",
                    keepAlive: true,
                },
            },
        ],
    },
    // 客户结算材料打印
    {
        path: "/settleMaterialPrint/print",
        name: "materialPrint",
        component: () => import("../views/settlement/statements/form/print"),
        meta: {
            title: "打印",
        },
    },
    {
        path: "/statements",
        name: "statements",
        component: Layout,
        redirect: "/statements/index",
        children: [
            {
                path: "/statements/index",
                name: "statementsIndex",
                component: () => import("../views/settlement/statements/index"),
                meta: {
                    title: "客户材料结算单",
                    keepAlive: true,
                },
            },
            {
                path: "/statements/detail",
                name: "statementsDetail",
                component: () => import("../views/settlement/statements/form/form"),
                meta: {
                    title: "客户结算-结算单明细",
                },
            },
            {
                path: "/statements/detailXingjie",
                name: "statementsDetailXingjie",
                component: () =>
                    import("../views/settlement/statements/form/formXingjie"),
                meta: {
                    title: "客户结算-结算单利润率明细",
                },
            },
        ],
    },
    {
        path: "/settlementBase",
        name: "settlementBase",
        component: Layout,
        redirect: "/settlementBase/index",
        children: [
            {
                path: "/settlementBase/index",
                name: "settlementBaseIndex",
                component: () => import("../views/settlement/base/index"),
                meta: {
                    title: "客户结算-申请结算",
                    keepAlive: true,
                },
            },
            {
                path: "/settlementSettle/index",
                name: "settlementSettleBaseList",
                component: () => import("../views/settlement/base/form/index"),
                meta: {
                    title: "客户结算-结算单",
                    keepAlive: true,
                },
            },
            {
                path: "/settlementSettle/detail",
                name: "settlementSettleBaseDetail",
                component: () => import("../views/settlement/base/form/detail"),
                meta: {
                    title: "结算明细列表",
                },
            },
        ],
    },
    {
        path: "/settlementManager",
        name: "settlementManagerIndex",
        component: Layout,
        redirect: "/settlementManager/index",
        children: [
            {
                path: "/settlementManager/houseDelivery",
                name: "houseDelivery",
                component: () => import("../views/settlement/houseDelivery/index"),
                meta: {
                    title: "交房管理",
                    keepAlive: true,
                },
            },
            {
                path: "/settlementManager/houseDelivery/settlement",
                name: "houseDeliverySettlement",
                component: () => import("../views/settlement/houseDelivery/form/settlement"),
                meta: {
                    title: "交房结算",
                },
            },
            {
                path: "/settlementManager/deductProfitView",
                name: "deductProfitView",
                component: () => import("../views/settlement/houseDelivery/form/deductProfitView"),
                meta: {
                    title: "倒扣利润明细",
                },
            },
            {
                path: "/settlementManager/index",
                name: "settlementManager",
                component: () => import("../views/settlement/manager/index"),
                meta: {
                    title: "项目经理结算",
                    keepAlive: true,
                },
            },
            {
                path: "/settlement/manager/add",
                name: "settlementAdd",
                component: () => import("../views/settlement/manager/add"),
                meta: {
                    title: "新增项目经理结算",
                },
            },
            {
                path: "/settlement/manager/update",
                name: "settlementUpdate",
                component: () => import("../views/settlement/manager/update"),
                meta: {
                    title: "修改项目经理结算",
                },
            },
            {
                path: "/settlement/manager/detail",
                name: "settlementDetail",
                component: () => import("../views/settlement/manager/form/mdetail"),
                meta: {
                    title: "结算明细列表",
                },
            },
            {
                path: "/statements/detail",
                name: "statementsDetails",
                component: () => import("../views/settlement/statements/form/detail"),
                meta: {
                    title: "项目经理结算-新增",
                },
            },
        ],
    },
    {
        path: "/project",
        name: "project_index",
        component: Layout,
        redirect: "/project/index",
        children: [
            {
                path: "/project/Auxiliary/index",
                name: "auxiliaryIndex",
                component: () => import("../views/project/auxiliary/index"),
                meta: {
                    title: "辅材申购单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/auxiliaryDetail",
                name: "auxiliaryDetail",
                component: () => import("../views/project/auxiliary/auxiliaryDetail"),
                meta: {
                    title: "辅材申购单详情",
                },
            },
            {
                path: "/project/index",
                name: "projectIndex",
                component: () => import("../views/project/index"),
                meta: {
                    title: "项目管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/management/projectDetail",
                name: "projectDetail",
                component: () => import("../views/project/management/projectDetail"),
                meta: {
                    title: "项目详情",
                },
            },
            {
                path: "/project/costManage",
                name: "costManageIndex",
                component: () => import("../views/project/costManage/index"),
                meta: {
                    title: "成本管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/assessment",
                name: "assessmentIndex",
                component: () => import("../views/project/assessment/index"),
                meta: {
                    title: "目标利润管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/qualityReport",
                name: "qualityReportIndex",
                component: () => import("../views/project/qualityReport/index"),
                meta: {
                    title: "质量汇报管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/specialApprove",
                name: "specialApproveIndex",
                component: () => import("../views/project/specialApprove/index"),
                meta: {
                    title: "特批管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/specialApprove/update",
                name: "specialApproveUpdate",
                component: () => import("../views/project/specialApprove/update"),
                meta: {
                    title: "特批修改",
                },
            },
            {
                path: "/project/specialApprove/detail",
                name: "specialApproveDetail",
                component: () => import("../views/project/specialApprove/detail"),
                meta: {
                    title: "特批详情",
                },
            },
            {
                path: "/project/assessment/update",
                name: "assessmentUpdate",
                component: () => import("../views/project/assessment/update"),
                meta: {
                    title: "目标利润修改",
                },
            },
            {
                path: "/project/assessment/detail",
                name: "assessmentDetail",
                component: () => import("../views/project/assessment/detail"),
                meta: {
                    title: "目标利润明细",
                },
            },
            {
                path: "/project/addProject",
                name: "addProject",
                component: () => import("../views/project/addProject"),
                meta: {
                    title: "新增项目",
                },
            },
            {
                path: "/project/qualityManage",
                name: "projectQualityManage",
                component: () => import("../views/project/qualityManage/index"),
                meta: {
                    title: "质量管理",
                    keepAlive: true,
                },
            },
            {
                path: "/qualityManage/detail",
                name: "qualityDetail",
                component: () =>
                    import("../views/project/qualityManage/qualityCheckDetail"),
                meta: {
                    title: "验收详情",
                },
            },
            {
                path: "/qualityManage/landDetail",
                name: "landDetail",
                component: () =>
                    import("../views/project/qualityManage/landCheckDetail"),
                meta: {
                    title: "拆改建验收详情",
                },
            },
            {
                path: "/project/changeManage",
                name: "projectChangeManage",
                component: () => import("../views/project/projectChangeManage/index"),
                meta: {
                    title: "项目变更管理",
                    keepAlive: true,
                },
            },
            /*{
          path: '/projectChangeManage/projectChange',
          name: 'projectChange',
          component:()=>import('../views/project/projectChangeManage/projectChange'),
          meta: {title: '项目变更管理录入'}
      },*/
            {
                path: "/projectChangeManage/projectChange",
                name: "projectChangeManager",
                component: () =>
                    import("../views/project/projectChangeManage/change/index"),
                meta: {
                    title: "项目变更管理录入",
                },
            },
            {
                path: "/projectChangeManage/projectChange/detail",
                name: "projectChangeDetail",
                component: () =>
                    import("../views/project/projectChangeManage/change/detail"),
                meta: {
                    title: "项目变更详情",
                },
            },
            {
                path: "/project/management/index",
                name: "projectManagementIndex",
                component: () => import("../views/project/management/index"),
                meta: {
                    title: "项目管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/stopAgreement/index",
                name: "projectStopAgreementIndex",
                component: () => import("../views/project/management/detials/stopAgreement/index.vue"),
                meta: {
                    title: "项目终止协议",
                },
            },
            {
                path: "/project/application/index",
                name: "kickOff",
                component: () => import("../views/project/kickOff/index"),
                meta: {
                    title: "施工申请管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/forwardDeliveryHousing/index",
                name: "forwardDeliveryHousing",
                component: () =>
                    import("../views/project/forwardDeliveryHousing/index"),
                meta: {
                    title: "期房项目管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/civilEngineering/index",
                name: "civilEngineering",
                component: () => import("../views/project/civilEngineering/index"),
                meta: {
                    title: "拆改建项目管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/civilIndex",
                name: "civilIndex",
                component: () => import("../views/project/civilEngineering/civilIndex"),
                meta: {
                    title: "拆改建验收",
                },
            },
            {
                path: "/project/dispatch/index",
                name: "projectDispatchIndex",
                component: () => import("../views/project/dispatch/index"),
                meta: {
                    title: "派工管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/detial/index",
                name: "dispatchDetial",
                component: () => import("../views/project/dispatch/dispatchDetial"),
                meta: {
                    title: "派工详情",
                },
            },
            {
                path: "/project/plan/index",
                name: "projectPlanIndex",
                component: () => import("../views/project/plan/index"),
                meta: {
                    title: "计划管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/plan/formulate",
                name: "projectPlanFormulate",
                component: () => import("../views/project/plan/formulate"),
                meta: {
                    title: "制定施工计划",
                },
            },
            {
                path: "/project/plan/materials",
                name: "projectPlanMaterials",
                component: () => import("../views/project/plan/materials"),
                meta: {
                    title: "制定材料计划",
                },
            },
            {
                path: "/project/plan/materials/execute",
                name: "projectPlanMaterialsExecute",
                component: () => import("../views/project/plan/execute/index"),
                meta: {
                    title: "执行施工计划",
                },
            },
        ],
    },
    {
        path: "/projOutsourceCivil",
        name: "projOutsourceCivil",
        component: Layout,
        redirect: "/project/projOutsourceCivil/index",
        children: [
            {
                path: "/project/projOutsourceCivil/index",
                name: "projOutsourceCivilIndex",
                component: () => import("../views/project/outsourceCivil/index"),
                meta: {
                    title: "外包拆改建管理",
                    keepAlive: true,
                },
            },
            {
                path: "/project/projOutsourceCivil/add",
                name: "projOutsourceCivilAdd",
                component: () => import("../views/project/outsourceCivil/form/add"),
                meta: {
                    title: "新增外包拆改建",
                },
            },
            {
                path: "/project/projOutsourceCivil/lookDetail",
                name: "projOutsourceCivilLookDetail",
                component: () => import("../views/project/outsourceCivil/form/detail"),
                meta: {
                    title: "外包拆改建详情",
                },
            },
        ],
    },
    //商品管理
    {
        path: "/goods",
        name: "goods",
        component: Layout,
        redirect: "/goods/index",
        children: [
            {
                path: "/goods/attributeMgr/index",
                name: "goodsAttributeMgrIndex",
                component: () => import("../views/goods/attributeMgr/index"),
                meta: {
                    title: "商品属性管理",
                },
            },
            {
                path: "/goods/attributeMgr/addCommodity",
                name: "goodsAttributeMgrAddCommodity",
                component: () => import("../views/goods/attributeMgr/addCommodity"),
                meta: {
                    title: "新增商品属性",
                },
            },
            {
                path: "/goods/attributeMgr/commodityProperty",
                name: "goodsAttributeCommodityProperty",
                component: () =>
                    import("../views/goods/attributeMgr/commodityProperty"),
                meta: {
                    title: "商品属性项管理",
                },
            },
            {
                path: "/goods/spuMgr/index",
                name: "goodsSpuMgrIndex",
                component: () => import("../views/goods/spuMgr/index"),
                meta: {
                    title: "商品SPU管理",
                },
            },
            {
                path: "/goods/mgr/index",
                name: "goodsMgrIndex",
                component: () => import("../views/goods/mgr/index"),
                meta: {
                    title: "商品管理",
                },
            },
            {
                path: "/goods/mgr/editMgr",
                name: "goodsMgrEditMgr",
                component: () => import("../views/goods/mgr/editMgr"),
                meta: {
                    title: "新增商品",
                },
            },
            {
                path: "/goods/catalog/index",
                name: "goodsCatalogIndex",
                component: () => import("../views/goods/catalog/index"),
                meta: {
                    title: "商品分类管理",
                },
            },
            {
                path: "/goods/price/index",
                name: "goodsPriceIndex",
                component: () => import("../views/goods/price/index"),
                meta: {
                    title: "商品价格管理",
                },
            },
        ],
    },
    //yyh
    {
        path: "/settingTarget",
        name: "settingTarget",
        component: Layout,
        redirect: "/settingTarget/index",
        children: [
            {
                path: "/settingTarget/index",
                name: "settingTargetIndex",
                component: () => import("../views/biz/settingTarget/index"),
                meta: {
                    title: "目标财年",
                },
            },
        ],
    },



    {
        path: "/settingTargetType",
        name: "settingTargetType",
        component: Layout,
        redirect: "/settingTargetType/index",
        children: [
            {
                path: "/settingTargetType/index",
                name: "settingTargetTypeIndex",
                component: () => import("../views/biz/settingTargetType/index"),
                meta: {
                    title: "目标类型维护",
                },
            },
        ],
    },




    {
        path: "/projectFeeManagement",
        name: "projectFeeManagement",
        component: Layout,
        redirect: "/projectFeeManagement/index",
        children: [
            {
                path: "/projectFeeManagement/index",
                name: "projectFeeManagementIndex",
                component: () => import("../views/project/projectFeeManagement/index"),
                meta: {
                    title: "工费发放周期管理",
                },
            },
            {
                path: "/projectFeeManagement/distributionDetails",
                name: "distributionDetails",
                component: () => import("../views/project/projectFeeManagement/distributionDetails"),
                meta: {
                    title: "工费发放周期管理明细",
                },
            },
        ],
    },
    {
        path: "/settingValue",
        name: "settingValue",
        component: Layout,
        redirect: "/settingValue/index",
        children: [
            {
                path: "/settingValue/index",
                name: "settingValueIndex",
                component: () => import("../views/biz/settingValue/index"),
                meta: {
                    title: "目标产值维护",
                },
            },
            {
                path: "/channelSetting/index",
                name: "channelSetting",
                component: () => import("../views/biz/settingValue/channel/index"),
                meta: {
                    title: "渠道目标产值维护", keepAlive: true
                },
            },
            {
                path: "/channelSetting/edit",
                name: "channelSettingEdit",
                component: () => import("../views/biz/settingValue/channel/edit"),
                meta: {
                    title: "渠道目标产值维护(编辑)"
                },
            },
        ],
    },
    {
        path: "/profitSplit",
        name: "profitSplit",
        component: Layout,
        redirect: "/profitSplit/index",
        children: [
            {
                path: "/profitSplit/index",
                name: "profitSplitIndex",
                component: () => import("../views/biz/profitSplit/index"),
                meta: {
                    title: "派单表",
                },
            },
            {
                path: "/profitSplit/addProfit",
                name: "addProfit",
                component: () => import("../views/biz/profitSplit/addProfit"),
                meta: {
                    title: "新增编辑派单表",
                },
            },
            {
                path: "/profitSplit/selectProfit",
                name: "selectProfit",
                component: () => import("../views/biz/profitSplit/selectProfit"),
                meta: {
                    title: "查看派单表",
                },
            },
        ],
    },
    {
        path: "/targetDefend",
        name: "targetDefendIndex",
        component: Layout,
        redirect: "/targetDefend/index",
        children: [
            {
                path: "/targetDefend/index",
                name: "targetDefend",
                component: () => import("../views/project/projTargetDefend/index"),
                meta: {
                    title: "工程目标维护",
                },
            },
        ],
    },

    {
        path: "/delayReason",
        name: "delayReason",
        component: Layout,
        redirect: "/project/delay/reason",
        children: [
            {
                path: "/project/delay/reason",
                name: "delayReasonProject",
                component: () => import("../views/project/projDelayReason/delayReason"),
                meta: {
                    title: "工程延期信息表",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/proj",
        name: "proj",
        component: Layout,
        redirect: "/proj",
        children: [
            {
                path: "/project/budget",
                name: "budgetProject",
                component: () => import("../views/project/statement/budgetDetails"),
                meta: {
                    title: "项目预算明细",
                    keepAlive: true,
                },
            },
            {
                path: "/project/internalBudget",
                name: "internalBudget",
                component: () => import("../views/project/statement/projInternalBudget"),
                meta: {
                    title: "项目内部预算",
                    keepAlive: true,
                },
            },
            {
                path: "/project/resource",
                name: "resourceProject",
                component: () =>
                    import("../views/project/statement/engineeringResources"),
                meta: {
                    title: "工程总资源",
                },
            },
            {
                path: "/project/planSpeed",
                name: "planSpeed",
                component: () => import("../views/project/planSpeed/planSpeed"),
                meta: {
                    title: "进度报表",
                },
            },
        ],
    },
    {
        path: "/resource",
        name: "resource",
        component: Layout,
        redirect: "/resource",
        children: [
            {
                path: "/customerResource/index",
                name: "customerResource",
                component: () => import("../views/biz/resource/customerResource/index"),
                meta: {
                    title: "资源段报表",
                    keepAlive: true,
                },
            },
            {
                path: "/orderService/customer",
                name: "orderServiceCustomer",
                component: () => import("../views/biz/resource/orderService/customer"),
                meta: {
                    title: "服务订单资源报表",
                    keepAlive: true,
                },
            },
            {
                path: "/projectData/index",
                name: "projectData",
                component: () => import("../views/project/statement/projData/index"),
                meta: {
                    title: "工程数据查看报表",
                    keepAlive: true,
                },
            },
            {
                path: "/customerOrderOnlineReport/index",
                name: "CustomerOrderOnlineReport",
                component: () =>
                    import("../views/biz/resource/customerOrderOnlineReport/index"),
                meta: {
                    title: "网销客户资源管理",
                    keepAlive: true,
                },
            },
            {
                path: "/customerChannelReport/index",
                name: "customerChannelReport",
                component: () =>
                    import("../views/biz/resource/customerChannelReport/index"),
                meta: {
                    title: "网销渠道管理看板",
                    keepAlive: true,
                },
            },
            {
                path: "/performanceStandards/index",
                name: "performanceStandards",
                component: () =>
                    import("../views/biz/resource/performanceStandards/index"),
                meta: {
                    title: "网销业绩数据达成表",
                    keepAlive: true,
                },
            },
            {
                path: "/customerOrderReport/index",
                name: "CustomerOrderReport",
                component: () =>
                    import("../views/biz/resource/customerOrderReport/index"),
                meta: {
                    title: "营销资源盯控",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/afterSale",
        name: "afterSale",
        component: Layout,
        redirect: "/afterSale",
        children: [
            {
                path: "/startWork/index",
                name: "startWorkIndex",
                component: () => import("../views/afterSale/startWork/index"),
                meta: {
                    title: "开工令满意度报表",
                    keepAlive: true,
                },
            },
            {
                path: "/endWork/index",
                name: "endWorkIndex",
                component: () => import("../views/afterSale/endWork/index"),
                meta: {
                    title: "完工满意度报表",
                    keepAlive: true,
                },
            },
            {
                path: "/publicPraise/index",
                name: "afterSaleStartWork",
                component: () => import("../views/afterSale/publicPraise/index"),
                meta: {
                    title: "口碑评价报表",
                    keepAlive: true,
                },
            },
            {
                path: "/maintenanceService/index",
                name: "afterSaleEndWork",
                component: () => import("../views/afterSale/maintenanceService/index"),
                meta: {
                    title: "维修服务统计报表",
                    keepAlive: true,
                },
            },
            {
                path: "/overallSatisfaction/index",
                name: "overallSatisfaction",
                component: () => import("../views/afterSale/overallSatisfaction/index"),
                meta: {
                    title: "满意度综合报表",
                    keepAlive: true,
                },
            }
        ],
    },
    {
        path: "/engineering",
        name: "engineering",
        component: Layout,
        redirect: "/engineering",
        children: [
            {
                path: "/engineering/index",
                name: "engineeringIndex",
                component: () =>
                    import("../views/project/statement/engineeringKanBan/index"),
                meta: {
                    title: "工程看板",
                },
            },
        ],
    },
    {
        path: "/proDelivery",
        name: "proDelivery",
        component: Layout,
        redirect: "/proDelivery",
        children: [
            {
                path: "/proDelivery/index",
                name: "proDeliveryIndex",
                component: () => import("../views/project/projectDelivery/index"),
                meta: {
                    title: "工程交付数据",
                },
            },
        ],
    },
    {
        path: "/projHouseFinance",
        name: "projHouseFinance",
        component: Layout,
        redirect: "/projHouseFinance",
        children: [
            {
                path: "/projHouseFinance/index",
                name: "projHouseFinanceIndex",
                component: () => import("../views/project/projectHouseFinance/index"),
                meta: {
                    title: "交房交款达成表",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/delivery/complete",
        name: "deliveryComplete",
        component: Layout,
        redirect: "/delivery/complete",
        children: [
            {
                path: "/delivery/complete",
                name: "deliveryCompleteIndex",
                component: () => import("../views/project/deliveryComplete/index"),
                meta: {
                    title: "交房达成表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/costBoard",
        name: "costBoard",
        component: Layout,
        redirect: "/costBoard/index",
        children: [
            {
                path: "/costBoard/index",
                name: "costBoardIndex",
                component: () => import("../views/project/costBoard/index"),
                meta: {
                    title: "成本统计报表",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/proStart",
        name: "proStart",
        component: Layout,
        redirect: "/proStart",
        children: [
            {
                path: "/proStart/index",
                name: "proStartIndex",
                component: () => import("../views/project/proStart/index"),
                meta: {
                    title: "开工准备子项报表",
                },
            },
        ],
    },
    {
        path: "/view",
        name: "view",
        component: Layout,
        redirect: "/view",
        children: [
            {
                path: "/view",
                name: "view_preview_view",
                component: () => import("../views/preview/view"),
                meta: {
                    title: "发布预览",
                },
            },
        ],
    },
    {
        path: "/worker",
        name: "worker",
        component: Layout,
        redirect: "/worker/laborCost/index",
        children: [
            {
                path: "/worker/laborCost/index",
                name: "workerLaborCost",
                component: () => import("../views/worker/laborCost/index"),
                meta: {
                    title: "工费管理",
                    keepAlive: true,
                },
            },
            {
                path: "/worker/laborCost/add",
                name: "workerLaborAdd",
                component: () => import("../views/worker/laborCost/add"),
                meta: {
                    title: "工费录入",
                },
            },
            {
                path: "/worker/account/index",
                name: "workerAccount",
                component: () => import("../views/worker/account/index"),
                meta: {
                    title: "工人管理",
                    keepAlive: true,
                },
            },
            {
                path: "/worker/account/workerDetail",
                name: "workerDetail",
                component: () => import("../views/worker/account/workerDetail"),
                meta: {
                    title: "工人详情",
                },
            },
            {
                path: "/worker/account/workerEdit",
                name: "workerEdit",
                component: () => import("../views/worker/account/workerEdit"),
                meta: {
                    title: "工人编辑",
                },
            },
            {
                path: "/worker/wageBatches/index",
                name: "workerWageBatches",
                component: () => import("../views/worker/wageBatches/index"),
                meta: {
                    title: "付款单批次",
                    keepAlive: true,
                },
            },
            {
                path: "/worker/wageBatches/detail",
                name: "workerWageBatchesDetail",
                component: () => import("../views/worker/wageBatches/detail"),
                meta: {
                    title: "工费单"
                },
            },
            {
                path: "/worker/projectManager/index",
                name: "projectManager",
                component: () => import("../views/worker/projectManager/index"),
                meta: {
                    title: "项目经理管理",
                    keepAlive: true,
                },
            },
            {
                path: "/worker/projectManager/workerEdit",
                name: "projectManagerEdit",
                component: () => import("../views/worker/projectManager/workerEdit"),
                meta: {
                    title: "项目经理编辑",
                },
            },
            {
                path: "/worker/projectManager/workerDetail",
                name: "projectManagerDetail",
                component: () => import("../views/worker/projectManager/workerDetail"),
                meta: {
                    title: "项目经理详情",
                },
            },
            {
                path: "/worker/amountConfig/index",
                name: "amountConfigManager",
                component: () => import("../views/worker/amountConfig/index"),
                meta: {
                    title: "保证金规则配置",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/workerProject",
        name: "workerProject",
        component: Layout,
        redirect: "/worker/project/index",
        children: [
            {
                path: "/worker/project/index",
                name: "workerProjectIndex",
                component: () => import("../views/worker/project/index"),
                meta: {
                    title: "项目管理",
                    keepAlive: true,
                },
            },
            {
                path: "/worker/projectDetial",
                name: "workerProjectDetial",
                component: () => import("../views/worker/project/dispatchDetial"),
                meta: {
                    title: "工人派工详情",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/projectWorkReport",
        name: "projectWorkReport",
        component: Layout,
        redirect: "/projectWorkReport/index",
        children: [
            {
                path: "/projectWorkReport/index",
                name: "projectWorkReportIndex",
                component: () => import("../views/project/projectWorkReport/index"),
                meta: {
                    title: "工人日报报表",
                    keepAlive: true,
                },
            },
            {
                path: "/projectWorkReport/form/detail",
                name: "projectWorkReportDetail",
                component: () =>
                    import("../views/project/projectWorkReport/form/detail"),
                meta: {
                    title: "工人日报报表详情",
                },
            },
        ],
    },

    {
        path: "/esign",
        name: "esign",
        component: Layout,
        redirect: "/esign/index",
        children: [
            {
                path: "/esign/esignUser/index",
                name: "/esignUser",
                component: () => import("../views/esign/esignUser/index"),
                meta: {
                    title: "认证账号管理",
                    keepAlive: true,
                },
            },
            {
                path: "/esign/esignOrg/index",
                name: "/esignOrg",
                component: () => import("../views/esign/esignOrg/index"),
                meta: {
                    title: "企业认证账号管理",
                    keepAlive: true,
                },
            },
            {
                path: "/esign/supply/index",
                name: "/esignSupply",
                component: () => import("../views/esign/supplyEsign/edit"),
                meta: {
                    title: "供应商认证",
                    keepAlive: true,
                },
            },
        ],
    },

    {
        path: "/projectManagerReport",
        name: "projectManagerReport",
        component: Layout,
        redirect: "/projectManagerReport/index",
        children: [
            {
                path: "/projectManagerReport/index",
                name: "projectManagerReportIndex",
                component: () => import("../views/project/projectManagerReport/index"),
                meta: {
                    title: "项目经理汇报报表",
                    keepAlive: true,
                },
            },
            {
                path: "/projectManagerReport/form/detail",
                name: "projectManagerReportDetail",
                component: () =>
                    import("../views/project/projectManagerReport/form/detail"),
                meta: {
                    title: "项目经理汇报报表详情",
                },
            },
        ],
    },
    {
        path: "/cmdFilePdf",
        name: "cmdFilePdf",
        component: Layout,
        redirect: "/cmdFilePdf/index",
        children: [
            {
                path: "/cmdFilePdf/index",
                name: "cmdFilePdfIndex",
                component: () => import("../views/base/cmdFilePdf/index"),
                meta: {
                    title: "PDF文件管理",
                    keepAlive: true,
                },
            },
            {
                path: "/cmdFilePdf/add",
                name: "cmdFilePdfAdd",
                component: () => import("../views/base/cmdFilePdf/add"),
                meta: {
                    title: "新增PDF文件",
                },
            },
        ],
    },
    {
        path: "/bizOrderMaterialOrg",
        name: "bizOrderMaterialOrg",
        component: Layout,
        redirect: "/bizOrderMaterialOrg/index",
        children: [
            {
                path: "/bizOrderMaterialOrg/index",
                name: "bizOrderMaterialOrgIndex",
                component: () => import("../views/biz/bizOrderMaterialOrg/index"),
                meta: {
                    title: "销售占款比例",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/budQuota",
        name: "budQuota",
        component: Layout,
        redirect: "/budQuota/index",
        children: [
            {
                path: "/budQuota/index",
                name: "budQuotaIndex",
                component: () => import("../views/biz/budQuota/index"),
                meta: {
                    title: "定额库",
                    keepAlive: true,
                },
            },
            {
                path: "/budQuota/add",
                name: "budQuotaAdd",
                component: () => import("../views/biz/budQuota/add"),
                meta: {
                    title: "新增定额",
                    // keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/budMaterial",
        name: "budMaterial",
        component: Layout,
        redirect: "/budMaterial/index",
        children: [
            {
                path: "/budMaterial/index",
                name: "budMaterialIndex",
                component: () => import("../views/biz/budMaterial/index"),
                meta: {
                    title: "材料库",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/budQuotaGroup",
        name: "budQuotaGroup",
        component: Layout,
        redirect: "/budQuotaGroup/index",
        children: [
            {
                path: "/budQuotaGroup/index",
                name: "budQuotaGroupIndex",
                component: () => import("../views/biz/budQuotaGroup/index"),
                meta: {
                    title: "定额分组",
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/budBudgetManage",
        name: "budBudgetManage",
        component: Layout,
        redirect: "/budBudgetManage/index",
        children: [
            {
                path: "/budBudgetManage/index",
                name: "budBudgetManageIndex",
                component: () => import("../views/biz/budBudgetManage/index"),
                meta: {
                    title: "预算管理（新）",
                    keepAlive: true,
                },
            },
            {
                path: "/budBudgetManage/commissioner",
                name: "budBudgetManageCommissioner",
                component: () => import("../views/biz/budBudgetManage/commissioner"),
                meta: {
                    title: "预核算员派单管理",
                    keepAlive: true,
                },
            },
            {
                path: "/budBudgetManage/previewCostByService",
                name: "previewCostByService",
                component: () => import("../views/biz/budBudgetManage/previewCost"),
                meta: {
                    title: "预算成本发包报表",
                },
            },

            {
                path: "/budgetList/index",
                name: "budgetListIndex",
                component: () => import("../views/biz/budBudgetManage/budgetList/index"),
                meta: {
                    title: "预算列表",
                },
            },
            {
                path: "/budgetList/projectBudget",
                name: "projectBudget",
                component: () => import("../views/biz/budBudgetManage/budgetList/projectBudget"),
                meta: {
                    title: "工程预算",
                },
            },
            {
                path: "/budgetList/preview",
                name: "previewBudgeList",
                component: () => import("../views/biz/budBudgetManage/budgetList/preview"),
                meta: {
                    title: "预算浏览",
                },
            },
            {
                path: "/budgetList/previewCost",
                name: "previewCost",
                component: () => import("../views/biz/budBudgetManage/budgetList/previewCost"),
                meta: {
                    title: "预算成本发包报表",
                },
            },


            {
                path: "/budgetList/add",
                name: "projectBudgetAddQuota",
                component: () => import("../views/biz/budBudgetManage/budgetList/add"),
                meta: {
                    title: "新增自定义定额",
                },
            },
            {
                path: "/budgetList/viewCost",
                name: "projectViewCost",
                component: () => import("../views/biz/budBudgetManage/budgetList/viewCost"),
                meta: {
                    title: "费用组成",
                },
            },
        ],
    },
    {
        path: "/satisfactionScore",
        name: "satisfactionScore",
        component: Layout,
        redirect: "/satisfactionScore/index",
        children: [
            {
                path: "/satisfactionScore/index",
                name: "satisfactionScoreIndex",
                component: () => import("../views/biz/customerService/satisfactionScore/index"),
                meta: {
                    title: "员工满意度分数管理",
                    keepAlive: true,
                },
            },
        ],
    },
];
